var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, true);
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, false);
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, useCapture);
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus = this.element.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal() {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight(){
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener('resize', this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".ProductSliderCell--Zoom",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );
  }
  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    var images = [],
        index = 0;
    if(this.slideshow){
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      var index_currentSlide = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index_currentSlide].querySelector('.ProductSlider--Element').getAttribute(
        'data-image-position'
      )
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }



    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    if (new Responsive().matchesBreakpoint('pocket')) {
      return;
    }

    // Create an array of images from the siblings of the target element.
    const images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (item.classList.contains('ProductSliderCell--Zoom') && item.querySelector('img')) {
        images.push(item.querySelector('img'));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(target.querySelector('.ProductSlider--Element').getAttribute('data-image-position'));

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(this.createPhotoSwipeItemsFromImages(images), imagePosition);
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = new Responsive().matchesBreakpoint("phone")
          ? 1200
          : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: new RevolutionImage().getSizedImageUrl(
          image.getAttribute("data-original-src"),
          requestedWidth + "x" + requestedHeight
        ),
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
              ".mainSwiper .ProductSliderCell--Zoom img"
            ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen('close', this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}
class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");

    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(".RevolutionSelectbox--Button");

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );


    this.domDelegate.on("click", "[data-action='close-selectbox']", this.closeDropdown.bind(this));
    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl
        .querySelector('[value="' + value + '"]')
        .setAttribute("checked", "true");
    }
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if(this.element.classList.contains('dropdownSelector')){
      this.element.querySelector('.RevolutionSelectbox--Item[disabled="true"]').removeAttribute('disabled');
      event.target.setAttribute('disabled','true');
    }
    this.closeDropdown(false,this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(false, this.element);
    }
  }

  selectboxSubmit(event, target) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(false, this.element);
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {

    var selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
      }


    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {

    event.preventDefault();
    var isOpen = target.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      this.closeDropdown(false, target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {

    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(new CustomEvent('close:search', { bubbles: true }));
    this.element.dispatchEvent(new CustomEvent('menu:close', { bubbles: true }));

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(target.parentElement.parentElement.children)
      .filter((item) => item.classList.contains('RevolutionSelectbox'));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item.querySelector('.RevolutionSelectbox--Button').setAttribute('aria-expanded', false);
      item.querySelector('.RevolutionSelectbox--Content').setAttribute('aria-hidden', true);
      item.querySelector('.RevolutionSelectbox--Content').style.display = 'none';
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add('is-visible');
      this.pageOverlayElement.addEventListener('click', this.onClickOutsideListener);
      const focus = this.element.querySelector('[data-scrollable]');
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      document.body.classList.add('scrollLock');
      trapFocus(this.mainDropdown);
      if (document.querySelector('#Drawer').getAttribute('aria-expanded') === 'true') {
        document.querySelector('.Drawer--Wrapper').style.overflow = 'visible';
      }
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    target.setAttribute('aria-expanded', true);
    target.parentElement.querySelector('.RevolutionSelectbox--Content').setAttribute('aria-hidden', false);
    target.parentElement.querySelector('.RevolutionSelectbox--Content').style.display = 'block';
    window.addEventListener('click', this.onClickOutsideListener);
  }

  closeDropdown(event, target) {
    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 300);
    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );

      const menuDrawer = document.querySelector('#Drawer');
      if(menuDrawer.getAttribute('aria-expanded') == "true"){
        document.querySelector('.Drawer--Wrapper').style.overflow = "auto";
              const focus = this.element.querySelector('[data-scrollable]');
              bodyScrollLock.enableBodyScroll(focus);
      }else{
        bodyScrollLock.clearAllBodyScrollLocks();
        document.body.classList.remove("scrollLock");
      }
      
     
    }
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() {}

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
        i = 0,
        _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );

  }

  // sort in the next fs
  addToCart() {

    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");

    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);

    const wrapper = formElement.closest(".Pdpvariants--product_title_wrapper") || formElement.closest(".ProductWrapper--ATC_quantity")
    const quantityElement = wrapper?.querySelector('.QuantitySelector__ProductQuantity');
    if (quantityElement) serialized.quantity = quantityElement.value;

    const rootUrl = window.Shopify?.routes?.root || '/';
    
    fetch(`${rootUrl}cart/add.js`, {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {

        if (window.location.href.indexOf("cart") != -1){
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );

      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }
}
class Dropdown {
  constructor(element) {
    this.element = element;
    this.domDelegate = new Delegate(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );
  }
  openDropdown(elem) {
    const DropdownButton = elem.querySelector(".Dropdown--Button"),
      DropdownContent = elem.querySelector(".Dropdown--Content");

    DropdownButton.setAttribute("aria-expanded", true);
    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeDropdown(elem) {
    const DropdownButton = elem.querySelector(".Dropdown--Button"),
      DropdownContent = elem.querySelector(".Dropdown--Content");
    new RevolutionAnimation(DropdownContent, true).slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
    setTimeout(function () {
      DropdownContent.setAttribute("aria-hidden", "true");
    }, 250);
  }

  toggleDropdown(event, target) {
    event.preventDefault(event);
    const mainDropdown = target.closest(".Dropdown");
    var isOpen = target.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      this.closeDropdown(mainDropdown, target);
    } else {
      this.openDropdown(mainDropdown, target);
    }
  }
}

(function (funcName, baseObj) {
  "use strict";
  // The public function name defaults to window.docReady
  // but you can modify the last line of this function to pass in a different object or method name
  // if you want to put them in a different namespace and those will be used instead of
  // window.docReady(...)
  funcName = funcName || "docReady";
  baseObj = baseObj || window;
  var readyList = [];
  var readyFired = false;
  var readyEventHandlersInstalled = false;

  // call this when the document is ready
  // this function protects itself against being called more than once
  function ready() {
    if (!readyFired) {
      // this must be set to true before we start calling callbacks
      readyFired = true;
      for (var i = 0; i < readyList.length; i++) {
        // if a callback here happens to add new ready handlers,
        // the docReady() function will see that it already fired
        // and will schedule the callback to run right after
        // this event loop finishes so all handlers will still execute
        // in order and no new ones will be added to the readyList
        // while we are processing the list
        readyList[i].fn.call(window, readyList[i].ctx);
      }
      // allow any closures held by these functions to free
      readyList = [];
    }
  }

  function readyStateChange() {
    if (document.readyState === "complete") {
      ready();
    }
  }

  // This is the one public interface
  // docReady(fn, context);
  // the context argument is optional - if present, it will be passed
  // as an argument to the callback
  baseObj[funcName] = function (callback, context) {
    if (typeof callback !== "function") {
      throw new TypeError("callback for docReady(fn) must be a function");
    }
    // if ready has already fired, then just schedule the callback
    // to fire asynchronously, but right away
    if (readyFired) {
      setTimeout(function () {
        callback(context);
      }, 1);
      return;
    } else {
      // add the function and context to the list
      readyList.push({ fn: callback, ctx: context });
    }
    // if document already ready to go, schedule the ready function to run
    // IE only safe when readyState is "complete", others safe when readyState is "interactive"
    if (
      document.readyState === "complete" ||
      (!document.attachEvent && document.readyState === "interactive")
    ) {
      setTimeout(ready, 1);
    } else if (!readyEventHandlersInstalled) {
      // otherwise if we don't have event handlers installed, install them
      if (document.addEventListener) {
        // first choice is DOMContentLoaded event
        document.addEventListener("load", ready, false);
        // backup is window load event
        window.addEventListener("DOMContentLoaded", ready, false);
      } else {
        // must be IE
        document.attachEvent("onreadystatechange", readyStateChange);
        window.attachEvent("onload", ready);
      }
      readyEventHandlersInstalled = true;
    }
  };
})("docReady", window);
// modify this previous line to pass in your own method name
// and object for the method to be attached to

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Responsive {
  constructor() {
    var _this = this;

    this.currentBreakpoint = this.getCurrentBreakpoint();

    window.addEventListener("resize", function () {
      var newBreakpoint = _this.getCurrentBreakpoint();

      if (_this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent("breakpoint:changed", {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );

      _this.currentBreakpoint = newBreakpoint;
    });
  }

  matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case "phone":
        return window.matchMedia("screen and (max-width: 640px)").matches;

      case "tablet":
        return window.matchMedia(
          "screen and (min-width: 641px) and (max-width: 1024px)"
        ).matches;

      case "tablet-and-up":
        return window.matchMedia("screen and (min-width: 768px)").matches;

      case "pocket":
        return window.matchMedia("screen and (max-width: 1024px)").matches;

      case "lap-and-up":
        return window.matchMedia("screen and (min-width: 1025px)").matches;

      case "desk":
        return window.matchMedia("screen and (min-width: 1280px)").matches;
    }
  }
  getCurrentBreakpoint() {
    if (window.matchMedia("screen and (max-width: 640px)").matches) {
      return "phone";
    }

    if (
      window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
        .matches
    ) {
      return "tablet";
    }

    if (
      window.matchMedia(
        "screen and (min-width: 1008px) and (max-width: 1279px)"
      ).matches
    ) {
      return "lap";
    }

    if (window.matchMedia("screen and (min-width: 1280px)").matches) {
      return "desk";
    }
  }
}
class RevolutionImage {
  constructor() {}

  getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return src.replace(/http(s)?:/, "");
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|webp|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
    } else {
      return null;
    }
  }
  getSupportedSizes(image, desiredSizes) {
    var supportedSizes = [],
      imageWidth = image["width"];

    desiredSizes.forEach(function (width) {
      if (imageWidth >= width) {
        supportedSizes.push(width);
      }
    });

    return supportedSizes;
  }
}

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }
    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {
    
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.$el[0],
          },
        })
      );
    });
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () {};
    this.onClose = options["onClose"] || function () {};
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    window.addEventListener("resize", this.calculateMaxHeightListener);

    this.delegateBody.on("cart-drawer:close-other", this._closeListener);

  }

  maxHeight() {
    const id = this.element.getAttribute("id");
    if (id == "quantityDrawer") {
      return;
    }
    this.element.style.height = window.innerHeight + "px";
    if (id == "cart" || id == "sidebarFavorites") {
      var footer = this.element.querySelector(".CartDrawer--Footer");
      var footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;
      }

      var header = this.element.querySelector(".CartHeader").offsetHeight;
      document.documentElement.style.setProperty("--cartHeader-height", header + "px");
      var cartItem = this.element.querySelector(".cartItem");
      if (cartItem !== null) {
        var itemHeight = cartItem.offsetHeight;
      }

      var itemWrapper = this.element.querySelector(".CartItems--Wrapper");


      if (itemWrapper !== null) {
        itemWrapper.style.height =
          window.innerHeight - footerHeight - header  + "px";
      }
    } else if (id == "sidebarDrawer") {
      this.element.style.height =
        window.innerHeight + "px";
    } else {
      var filterBar = document.querySelector(".FilterBar");
      var mobileHeader = document.querySelector(".header");
      var breakpoint = new Responsive().getCurrentBreakpoint();

      if (filterBar !== null && breakpoint == "phone") {
        var filterBarHeight = filterBar.offsetHeight;
        var mobileHeaderHeight = mobileHeader.offsetHeight;

        this.element.style.height =
          window.innerHeight  + "px";
      }
    }
  }

  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
    this.maxHeight();
    var drawerId = this.element.getAttribute("id");
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    if (drawerId == "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );

      if (this.element.querySelector(".emptyItem--Text")) {
        this.element.querySelector(".emptyItem--Text").style.display = "flex";
      }

      setTimeout(() => {
        var count = window.theme.cartCount;
        var options = JSON.parse(this.element.getAttribute("data-settings"));
      }, 200);
    }
    if (this.isOpen) {
      return;
    }

    this.element.dispatchEvent(
      new CustomEvent("cart-drawer:close-other", { bubbles: true })
    );

    this.maxHeight();

    if (drawerId == "sidebarDrawer") {
      if (document.querySelector(".SidebarDrawer__Close")) {
        document.querySelector(".SidebarDrawer__Close").style.display = "block";
      }


      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );
    } else if (drawerId == "favoritesDrawer") {
      this.element.dispatchEvent(
        new CustomEvent("favorite-product:open", {
          bubbles: true,
        })
      );
    }

    this.element.setAttribute("aria-expanded", "true");
    this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener("click", this._closeListener);

    var focus = this.element.querySelectorAll("[data-scrollable]");
    focus.forEach((item) => {
      bodyScrollLock.disableBodyScroll(item, bodyScrollLockOptions); 
    });
    document.body.classList.add("scrollLock");
    this.isOpen = true;
    setTimeout(() => {
      trapFocus(this.element);
    }, 400);
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }

    var drawerId = this.element.getAttribute("id");
    if (event) {
      event.preventDefault();
    }

   

    document.body.classList.remove("scrollLock");

    bodyScrollLock.clearAllBodyScrollLocks();
    if (drawerId == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
    }
    this.element.setAttribute("aria-expanded", "false");
    if (
      this.element.classList.contains("sizeDrawer_Wrapper") == true &&
      document.body.querySelector("#cart").getAttribute("aria-expanded") ==
        "true"
    ) {
      return;
    }



    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    removeTrapFocus(this.element);
    this.closeAnimation(this.element);
    this.isOpen = false;
    this.onClose();
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {

            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate = node.querySelectorAll("[data-animation]");
              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, i);
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

// A function to animate a list of elements by scaling them out
 elementScaleOut(elements) {
  // Get the animation duration and delay from the theme settings
  const animationDuration = window.theme.animationDuration * 2;
  const animationDelay = window.theme.animationBetweenElements;

  // Loop through each element in the list
  elements.forEach((element, index) => {
    // Check if the element has already been loaded
    if (element.hasAttribute("data-loaded")) {
      // If so, skip this element
      return;
    }

    // Mark the element as loaded to prevent duplicate animations
    element.setAttribute("data-loaded", true);

    // Define the animation keyframes
    const keyframes = [
      { transform: "scale(104%)", opacity: "0" },
      { transform: "scale(100%)", opacity: "1" },
    ];

    // Define the animation options
    const animationOptions = {
      duration: animationDuration,
      fill: "forwards",
    };

    // Schedule the animation with a delay based on the element's position in the list
    setTimeout(() => {
      element.animate(keyframes, animationOptions);
    }, animationDelay * index);
  });
}



  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }
  imageUnravel(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        item.classList.add("show"); // Add the 'show' class to reveal the image
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }
  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {
          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            elements.push(result.target);
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: 'elementFromTop',
          elementFromBottom: 'elementFromBottom',
          elementFromRight: 'elementFromRight',
          elementFromLeft: 'elementFromLeft',
          elementFromLeftBig: 'elementFromLeftBig',
          elementFromRightBig: 'elementFromRightBig',
          elementScaleIn: 'elementScaleIn',
          imageUnravel: 'imageUnravel',
          elementScaleOut: 'elementScaleOut'
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.25 }
    );

    if (animatedItem.classList.contains('animatedContent')){
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if(window.theme.enableAnimations){
  document.addEventListener("DOMContentLoaded", function() {
    new RevolutionAnimation();
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.counter = 0;
    this.counter = this.element.querySelector(".component-countDown");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const countDateString = `2030-03-03T${this.options["countdownTime"]}`;
    const countDate = new Date(countDateString);
    const nOfDays = this.options["countdownDays"];
    const difference = countDate - dateNow;

    var textDays = 0;
    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;
    const todaysDay = dateNow.getDay();

    const textHours = Math.floor((difference % days) / hours);
    const textMinutes = Math.floor((difference % hours) / minutes);
    const textSeconds = Math.floor((difference % minutes) / seconds);

    if (todaysDay == 1) {
      textDays = nOfDays;
    } else if (todaysDay == 0) {
      textDays = 0;
    } else {
      textDays = nOfDays - todaysDay;
      if (textDays < 0) {
        const mDays = todaysDay % nOfDays;
        textDays = nOfDays - mDays;
      }
    }

    if (this.options["excludeWeekends"] && todaysDay == 5) {
      textDays = textDays + 2;
    } else if (this.options["excludeWeekends"] && todaysDay == 6) {
      textDays = textDays + 1;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;
    if (textDays > 0 && nOfDays > 1) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}
customElements.define("countdown-element", Countdown);



class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.carousel = new RevolutionSwiper(this.carouselElement);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

   /* TEST 23 */
  }
}
customElements.define("slider-text", SliderTextSection);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.loader = this.element.querySelector(".itemLoader");
   this.cartCount = document.querySelector(".CartCount");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    new AddToCart(this.element);
    if (window.theme.enableAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.bindEvents();

    this.routeURL = window.Shopify?.routes?.route || "/";

  }
  onUnload() {
    this.delegateElement.off();
    document.removeEventListener("product:added", this.onProductAddedListener);
  }
  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".QuantitySelector__CurrentQuantity",
        this.updateItemQuantity.bind(this)
      );

      this.delegateElement.on("keypress", ".CartItem__QuantitySelector", this.handleEnterPress.bind(this));

      document.addEventListener(
        "cart:rerender",
        this.renderCart.bind(this)
      );

      window.theme.listener = "true";
    }
  }

  handleEnterPress() {
    if (event.key === "Enter") {
      event.preventDefault();
      this.updateItemQuantity(event, event.target);
    }
  }

  onOpen() {
    // Get the value of the aria-expanded attribute.
    const isExpanded = this.element.getAttribute("aria-expanded") === "true";

    // Early exit if the drawer is already expanded.
    if (isExpanded) {
      return;
    }

    // Calculate the height of the cart header and free shipping elements.
    const cartHeader = document.querySelector(".CartHeader");

    const cartHeaderHeight = cartHeader ? cartHeader.offsetHeight : 0;

    let totalHeight = cartHeaderHeight;

    // Set the height of the cart header using a CSS variable.
    /* if(window.theme.cartCount > 0 ){
       totalHeight = cartHeaderHeight;
    }  */
    document.documentElement.style.setProperty("--cartHeader-height", totalHeight + "px");
    // Load recommendations if the option is enabled.
    if (this.options.showRecommendations) {
      this.loadRecommendations();
    }
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();
    target.closest(".cartItem")?.querySelector(".itemLoader")?.classList.add("is-visible");

    const quantity = this.getQuantity(target);
    
    await fetch(`${this.routeURL}cart/change.js`, {
      body: JSON.stringify({
        id: target.getAttribute("data-line-id"),
        quantity: quantity,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
    
    this.renderCart(target.getAttribute("data-id"), true);
  }

  getQuantity(target) {
    let quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }

    const input = target.parentElement.querySelector("input");
    if (!input) return quantity;

    const min = parseInt(input.min);
    const max = parseInt(input.max);

    if (min && quantity < min) quantity = min;
    if (max && quantity > max) quantity = max;

    return quantity;
  }

  onProductAdded() {
    var _this = this;
    this.firstProductAdded = false;
    this.renderCart().then(function () {
      _this.sidebarDrawer.openDrawer();
    });
  }

  renderCart(lineNumber, quantityChange) {
    this.pageLoader.style.width = 100 + "%";
    let skipEvent = false;
    if(event && event.type == 'cart:rerender') {
      lineNumber = 'CartItem-' + event.detail.lineItem;
      quantityChange = event.detail.quantityChange;
       skipEvent = true;
    }
    var _this = this;

    return fetch(`${this.routeURL}?section_id=cart_drawer`, {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (html) {

        _this.replaceContent(html, lineNumber, quantityChange, skipEvent);
      });
    });
  }

  replaceContent(html, lineNumber, quantityChange, skipEvent) {
    var _this = this;
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = 0 + "px";
    this.pageLoader.style.width = 0 + "%";
    setTimeout(() => {
      this.pageLoader.style.left = 0 + "px";
      this.pageLoader.style.right = "unset";
    }, 550);
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    this.tempOptions = JSON.parse(
      tempElement.querySelector("#cart").getAttribute("data-settings")
    );
    
    const carted_products = tempElement.querySelector("cart-drawer").dataset.carted;    
    sessionStorage.setItem("carted_products", carted_products);

    this.element.dispatchEvent(new CustomEvent("cart:changed", { bubbles: true }));


    if(this.firstProductAdded) document.dispatchEvent(_this.changeEvent);
    this.firstProductAdded = true;

    var number = this.tempOptions["itemCount"];
    this.cartCount.innerHTML = `(${number})`;
    if (number > 0){
      document.querySelector('.fullHeaderIcon').setAttribute('aria-hidden','false');
      document.querySelector('.emptyHeaderIcon').setAttribute('aria-hidden','true');
    } else {
      document.querySelector('.fullHeaderIcon').setAttribute('aria-hidden','true');
      document.querySelector('.emptyHeaderIcon').setAttribute('aria-hidden','false');
    }
    window.theme.cartCount = parseInt(number);

    if (lineNumber) {
      lineNumber = lineNumber.split(":")[0];
      var cartNodeParent = this.element.querySelector("#" + lineNumber);

      const itemToReplaceWith = tempElement.querySelector(
        "#" + lineNumber + " .cartItem--Informations"
      );
      if (cartNodeParent && cartNodeParent.querySelector(".itemLoader")) {
        cartNodeParent
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
      }
      if (itemToReplaceWith) {
        cartNodeParent.replaceChild(
          itemToReplaceWith,
          cartNodeParent.querySelector(".cartItem--Informations")
        );
      } else {
        cartNodeParent.classList.add("removing");
        cartNodeParent.animate(
          [
            // keyframes
            { transform: "translateY(0px)", opacity: "1" },
            { transform: "translateY(30px)", opacity: "0" },
          ],
          {
            // timing options
            duration: 500,
            fill: "forwards",
          }
        );
        setTimeout(() => {
          cartNodeParent.remove();
        }, 500);

        if (this.options["showRecommendations"]) {
          this.loadRecommendations();
        }
      }

      if (number > 0) {
        const checkoutButtonParent = this.element.querySelector(
          ".CartDrawer--Footer"
        );
        const checkoutButtonToReplace = tempElement.querySelector(
          ".CartFooter--Totals"
        );
        const checkoutMetaParent = checkoutButtonParent.querySelector('.MetaIcon--Wrappers');
        if (checkoutMetaParent) {
          checkoutMetaParent.replaceChild(
            checkoutButtonToReplace,
            checkoutButtonParent.querySelector(".CartFooter--Totals")
          );
        }
      } else {
        this.element
          .querySelector(".CartDrawer--Footer")
          .classList.add("removing");

        const mainPartParent = this.element.querySelector(".CartDrawer");

        mainPartParent.innerHTML =
          tempElement.querySelector(".CartDrawer").innerHTML;

        if (window.theme.enableAnimations) {
          const mainPartchildren =
            mainPartParent.querySelector("#main-cartItems");
          mainPartchildren.animate(
            [
              // keyframes
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
          );
        }
      }
      if (this.element.querySelector(".itemLoader")) {
        setTimeout(() => {
          this.element
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        }, 250);
      }
    } else {
      const cartNodeParent =
        this.element.querySelector(".CartDrawer").parentNode;
      const currentScrollPosition =
        this.element.querySelector("#main-cartItems").scrollTop;

      cartNodeParent.replaceChild(
        tempElement.querySelector(".CartDrawer"),
        this.element.querySelector(".CartDrawer")
      );
      this.element.querySelector("#main-cartItems").scrollTop =
        currentScrollPosition;
      if (window.theme.enableAnimations) {
        new RevolutionAnimation(this.element);
      }
    }
    setTimeout(() => {
      if (this.options["showRecommendations"] && !quantityChange) {
        this.loadRecommendations();
      }
      if(!skipEvent){
        var focus = _this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      }

      _this.sidebarDrawer.maxHeight();
    }, 200);
  }

  loadRecommendations() {
    const _this = this;
    // Determine the URL to fetch recommendations based on the product ID option.
    const productId = this.options.productId;
    const url = productId
      ? `${window.Shopify?.routes?.route}recommendations/products?section_id=helper-recommendations&product_id=${productId}&limit=10`
      : "?section_id=helper-recommendations";

    // Fetch the recommendations and parse the HTML content.
    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (content) {
        const container = document.createElement("div");
        container.innerHTML = content;

        // Insert the recommendations HTML into the recommendations container.
       const upsellContainer = container.querySelector(".cartUpsell");
       const recommendationsContainer = _this.element.querySelector(".CartMobileRecommendations");
       recommendationsContainer.innerHTML = upsellContainer.innerHTML;


        // Initialize the Swiper instance with the recommendations container and options.
        const swiper = new Swiper(recommendationsContainer.querySelector(".swiperUpsell"), {
          slidesPerView: 2.2,
          spaceBetween: 16,
          slidesOffsetAfter: 16,
          slidesOffsetBefore: 16,
          loop: false,
          pagination: {
            el: ".sidecart_pagination",
            type: "bullets",
            clickable: true,
          },
          breakpoints: {
            1025: {
              slidesPerView: 2.7,
              spaceBetween: 16,
              slidesOffsetAfter: 32,
              slidesOffsetBefore: 32,
              navigation: {
                nextEl: ".swiperNextCart",
                prevEl: ".swiperPrevCart",
              },
            },
          },
        });


        // Dispatch a custom event to toggle favorites state.
        _this.element.dispatchEvent(new CustomEvent("favorites:toggle", { bubbles: true }));

        // Show the recommendations section and run the Revolution animation if enabled.
        const recommendationsSection = _this.element.querySelector(".cartRecommendations");
        recommendationsSection.style.display = "block";
        if (window.theme.enableAnimations) {
          new RevolutionAnimation(_this.element);
        }

         const cartDrawerRecommendation = _this.element.querySelector("#cartDrawer--recommendation");

        let cartDrawerSlidesRecommendation = _this.element.querySelectorAll('#cartDrawer--recommendation .cartSlideItem');

        if( cartDrawerSlidesRecommendation.length === 0 ){

          cartDrawerRecommendation.style.display = 'none';
        }
      })
      .catch(function (error) {
        // Handle the error gracefully by logging it or displaying an error message to the user.
        // For this implementation, we will not output errors to the console.
        // Instead, we can display an error message in the UI or send the error to a monitoring service.
      });
}
}
customElements.define("cart-drawer", CartDrawer);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.swiper = this.carousel.swiperElement;
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
      this.bindEvents();
      this.createObserver();
    } else {
      this.createObserver();
    }
  }

  bindEvents(){
    document.addEventListener("banner:disable", () => { this.swiper.allowTouchMove = false;	});
    document.addEventListener("banner:enable", (e) => { this.swiper.allowTouchMove = true; });
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    // Get the current breakpoint.
    const breakpoint = new Responsive().getCurrentBreakpoint();

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(this.element.querySelectorAll('.Banner__ImageContainer--Swap'));
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(cellElement.querySelectorAll('.Banner__ImageContainer--Swap'));
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      console.error('No image containers found.');
      return;
    }

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (breakpoint === 'pocket' || breakpoint === 'phone' || breakpoint === 'tablet') {
      imageToReveal = imageContainers[0].querySelector('.Banner__Image');
    } else {
      if (imageContainers.length < 2) {
        console.error('Not enough image containers found.');
        return;
      }
      imageToReveal = imageContainers[1].querySelector('.Banner__Image');
    }

    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === 'true') {
      console.error('Image not found or already loaded.');
      return;
    }

    // Replace the image URL with a higher quality version.
    const replaceUrl = imageToReveal.dataset.src.replace('{width}x', '2600x');
    imageToReveal.src = replaceUrl;
    imageToReveal.dataset.loadedImage = 'true';
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.logoWrapper = this.element.querySelector(".header--LogoWrapper");
    if(this.options.transparent) this.isTransparent = true;
    else this.isTransparent = false;
    this.pushed = true;
    this.retracted = false;
    this.mediaQueryBig = window.matchMedia("(min-width: 1025px)");
    this.userScroll = false;
    this.allMenuLinks = this.element.querySelectorAll('.mainLinks');
    this.heroBanner = document.querySelector('.Banner--FirstSection');

    if(!this.heroBanner) this.element.classList.remove('Header--Transparent');

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    document.querySelector('body').style.backgroundColor = getComputedStyle(this.element).backgroundColor;
    this.element.parentElement.style.pointerEvents = 'none';

    if(this.options.sticky){
      this.toggleSticky();
    }
    
    this.bindEvents();
    this.menuOverlapHandler();
    this.animationHandler();
  }

  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector(".header--MenuItems"),
      overlapping = false,
      menuWrapper = this.element.querySelector(".header--Wrapper"),
      allHeights = [],
      _this = this;
    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll(".mainLinks");
      desiredHeight.forEach((item) => {
        allHeights.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (
          window.theme.menuBreakpoint == 0 ||
          window.theme.menuBreakpoint == undefined
        ) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    if (currentClientWidth > window.theme.menuBreakpoint) {
      menuItems.classList.remove("mt-m");
      menuItems.classList.remove("mainMenu--Overlapping");
      menuWrapper.querySelector(".mainMenuItems").prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add("mt-m");
      menuItems.classList.add("mainMenu--Overlapping");
      menuItems.closest(".header").appendChild(menuItems);
    }
    document.documentElement.style.setProperty(
      "--header-height",
      _this.element.clientHeight + "px"
    );
    
    //menuItems.style.opacity = 1;
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");
  }

  debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  bindEvents() {
    const _this = this;
    document.addEventListener("shopify:section:load", function() {
      _this.menuOverlapHandlerListener();
    });
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    window.addEventListener("resize", this.menuOverlapHandlerListener);

    this.animationHandlerListener = this.animationHandler.bind(this);
    this.toggleColorListener = this.toggleColor.bind(this);
    this.debounceToggleAnimationListener = this.debounce(this.toggleHeaderAnimation.bind(this), 100);

    if(this.options.sticky || this.options.transparent) window.addEventListener("resize", this.animationHandlerListener);
    if(this.options.sticky || this.options.transparent) window.addEventListener("scroll", this.debounceToggleAnimationListener);
    window.addEventListener("scroll", this.toggleColorListener);

    if (this.options.transparent && this.heroBanner) {
      this.element.addEventListener("mouseenter", this.onMouseEnter.bind(this));
      this.element.addEventListener("mouseleave", this.onMouseLeave.bind(this));
    }

    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-hasMenu='true']",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .mainLinks",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "click",
      ".mainLinks",
      this.currentLink.bind(this), true
    );
  }

  updateMenuPosition(target){
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${document.querySelector('#header').offsetHeight}px` //Ovo ovako postavis, sklonis ono sto je sada
    );
  }

  openMenu(event, target) {
    // Dispatch a custom event to indicate that the menu is being opened.
    this.element.dispatchEvent(new CustomEvent('menu:open', { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === 'mouseenter' && target !== event.target) {
      return;
    }

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);
    this.element.classList.remove('Header--Transparent');
    target.setAttribute('aria-expanded', 'true');
    if(target.getAttribute("aria-expanded") === "true") target.classList.add('currentLink');

    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children)
                          .filter((sibling) => sibling !== target && sibling.getAttribute('aria-expanded') === 'true' && !sibling.hasAttribute("current-page"));
    siblings.forEach((item) => {
      item.setAttribute('aria-expanded', 'false');
      item.classList.remove('currentLink');
    });

   // Disable body scroll on the scrollable element inside the menu.
    const scrollableElement = this.element.querySelector('[data-scrollable]');
    if (scrollableElement) bodyScrollLock.disableBodyScroll(scrollableElement, bodyScrollLockOptions);

    document.querySelector(".pageOverlay")?.classList.add("is-visible");
    document.querySelector(".pageOverlay")?.classList.add("header-menu-dropdown-opened");
  }


  closeMenu(event, target) {
    if (event.type === "mouseleave" && target !== event.target){return;}
    if (this.options["transparent"] && this.isTransparent && this.heroBanner) {
      this.element.classList.add("Header--Transparent");
    }

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
        item.setAttribute("aria-expanded", "false");
    });

    if(target.parentElement.getAttribute("aria-expanded") === "false") {
      if(!target.parentElement.hasAttribute("current-page")) target.parentElement.classList.remove('currentLink');
      else if(target.parentElement.getAttribute("current-page") === false) target.parentElement.classList.remove('currentLink');
    }

    if(target.hasAttribute("aria-singlemenu")) {
      const siblings =  Array.from(target.parentElement.children).filter((sibling) => sibling !== target && !sibling.hasAttribute("current-page"));
      siblings.forEach((item) => item.classList.remove('currentLink'));
    }

    if (target.getAttribute("aria-hasMenu") === 'true' && target.getAttribute('current-page') !== 'true') {
      target.classList.remove('currentLink');
    }

    this.animationHandler();
    this.toggleColor();

    bodyScrollLock.clearAllBodyScrollLocks();
    document.querySelector(".pageOverlay")?.classList.remove("is-visible");
    document.querySelector(".pageOverlay")?.classList.remove("header-menu-dropdown-opened");
  }

  toggleColor() {
    if ( window.scrollY > 10){
      this.element.classList.add('Header--Scrolled');
    } else {
      this.element.classList.remove('Header--Scrolled');
    }
    if (this.options.transparent && this.isTransparent && this.heroBanner) {
      if (window.scrollY > 10 && this.options.sticky) {
        this.element.classList.remove("Header--Transparent");
      } else {
        this.element.classList.add("Header--Transparent");
      }
    }
  }

  currentLink(event, target){
    if (event.type === 'click' && target !== event.target) {return;}
    target = target.parentElement;

    const siblings = Array.from(target.parentElement.children).filter((sibling) => sibling !== target && sibling.classList.contains('currentLink') || sibling.hasAttribute("current-page"));
    siblings.forEach((sibling) => {
      sibling.classList.remove('currentLink')
      sibling.setAttribute("current-page", false);
    });

    target.classList.add('currentLink');
    target.setAttribute("current-page", true);
  }

  onMouseEnter() {
    this.isTransparent = false;
    this.element.classList.remove("Header--Transparent");
  }

  onMouseLeave() {
    this.isTransparent = true;
    if (window.scrollY <= 10) this.element.classList.add("Header--Transparent");
  }

  animationHandler(){
    if (this.mediaQueryBig.matches) {
      this.element.style.height = '';
      this.element.parentElement.style.height = '169px';
      document.documentElement.style.setProperty("--header-height", '169px');
      this.toggleHeaderAnimation();
    }
    else {
      this.element.style.height = '64px';
      this.element.parentElement.style.height = '64px';
      document.documentElement.style.setProperty("--header-height", '64px');
      this.disableHeaderAnimation();
    }
  }

  toggleHeaderAnimation(){
    if (this.mediaQueryBig.matches){
      if (!this.element.querySelector("[aria-expanded='true']")) {
        const annBarHeight = parseInt(getComputedStyle(document.querySelector('#shopify-section-announcement_bar')).height, 10);
        if (window.scrollY > annBarHeight) {
          this.retractSecondRow();
        } else {
          this.pushSecondRow();
        }
      }
    }
  }

  disableHeaderAnimation(){
    this.element.classList.remove("header--RowPushed");
    this.element.classList.remove("header--RowRetracted");
  }

  retractSecondRow(){
    this.retracted = true;

    this.element.classList.remove("header--RowPushed");
    this.element.classList.add("header--RowRetracted");

    if(this.pushed) this.pushed = false;
    document.documentElement.style.setProperty("--header-height","82px");

  }

  pushSecondRow(){
    this.pushed = true;

    this.element.classList.remove("header--RowRetracted");
    this.element.classList.add("header--RowPushed");

    if(this.retracted) this.retracted = false;
    document.documentElement.style.setProperty("--header-height","169px");

}
}
customElements.define("header-component", Header);

class Search extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    // Find result elements
    this.resultElements = this.element.querySelectorAll(".Search--Result");

    // Find buttons to toggle between products and articles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    new AddToCart(this.element);
    
    

  }

  connectedCallback() {
    // Toggle between products and articles when buttons are clicked
    this.delegateElement.on(
      "click",
      '[data-action="toggle-products"]',
      this.showProducts.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-articles"]',
      this.showArticles.bind(this)
    );
    this.delegateElement.on(
      "click",
      '.Button--Search',
      this.handleTabClick.bind(this)
    );

    this.showProducts();
    this.updateItemsNumber();


  }

  disconnectCallback(){
    this.delegateElement.destroy();
  }

  handleTabClick(event){
    const params = new URLSearchParams(window.location.search);
    const currentPage = params.get("page");
    
    event.preventDefault();

    if( currentPage > 1){
     params.set("page",1);
     const newUrl = `${window.location.pathname}?${params.toString()}`;
     window.location.href = newUrl;
    }

    this.hidePagination(event);
  }

  

  async updateItemsNumber(){
    const params = new URLSearchParams(window.location.search);
    params.append("section_id","ajax-search__tabs-helper");
    params.set("type","product article");
    params.set("page",1);

    const url = `${window.Shopify?.routes?.route || ""}/search?${params.toString()}`;

    const div = document.createElement("div");
    div.innerHTML = await this.fetchSection(url);

    // Swap product number
    const oldProductNumber = this.element.querySelector(".itemNumber");
    const newProductNumber = div.querySelector(".search__product-number");
    if (oldProductNumber && newProductNumber) {
      oldProductNumber.innerHTML = newProductNumber.innerHTML;
    }

    // Swap article number
    const oldArticleNumber = this.element.querySelector(".itemNumber_2");
    const newArticleNumber = div.querySelector(".search__article-number");
    if (oldArticleNumber && newArticleNumber) {
      oldArticleNumber.innerHTML = newArticleNumber.innerHTML;
    }

    const articleElements = this.element.querySelectorAll(".article-wrapper");
    const articleButton = this.element.querySelector("#articleBtn");

    requestAnimationFrame(() => {
      if(articleElements.length === 0){
        oldArticleNumber.innerHTML = 0;
        articleButton.style.pointerEvents = "none";
      }
    });

  }

  async fetchSection(url) {
    const settings = {
      credentials: "same-origin",
      method: "GET"
    };
    const response = await fetch(url, settings);
    return await response.text();
  }
  

  showProducts() {
    // Show product elements and hide article elements
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    if (!productElements.length) {
      return;
    }
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    
    articleElements.forEach((article) => {
      article.classList.add("hidden");
    });
    productElements.forEach((product) => {
      product.classList.remove("hidden");
    });

    // Update button styles
    this.openProductBtn.classList.add("active");
    this.openArticleBtn.classList.remove("active");

    this.openProductBtn.classList.add("u-s3");
    this.openProductBtn.classList.remove("u-p3");
    this.openArticleBtn.classList.add("u-p3");
  }

  showArticles() {
    
    // Show article elements and hide product elements
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    if (!articleElements.length) {
      return;
    }
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    productElements.forEach((product) => {
      product.classList.add("hidden");
    });
    articleElements.forEach((article) => {
      article.classList.remove("hidden");
    });

    // Update button styles
    this.openProductBtn.classList.remove("active");
    this.openArticleBtn.classList.add("active");

    this.openArticleBtn.classList.remove("u-p3");
    this.openArticleBtn.classList.add("u-s3");
    this.openProductBtn.classList.add("u-p3");
  }

  hidePagination(event){
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    const articleNumber = Number(this.element.querySelector(".itemNumber_2").innerText);

    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    const productNumber = Number(this.element.querySelector(".itemNumber").innerText);

    const pagination = this.element.querySelector(".Pagination-Wrapper");

    if(event.target.getAttribute("id") === "productBtn" && productElements.length < 24 && productNumber < 24){
      pagination.style.display="none";
    }else if
    (event.target.getAttribute("id") === "articleBtn" && articleElements.length < 24 && articleNumber < 24){
      pagination.style.display="none";
    }else{
      pagination.style.display="flex"
    }

    
   
  }

}

customElements.define("search-component", Search);


class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.SidebarMenu = new Drawer(this.element);
    this.dropdown = new Dropdown(this.element);
    this.carouselElement = this.element.querySelector(".MenuSlideshowMobile");

    this.bindEvents();
  }
  bindEvents() {
    document.addEventListener("sidebar-drawer:open", this.onDrawerListener);
  }
}
customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
var trans = new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;
    this.firstTimePlaying = true;
    this.userInteracted = false;
    this.videoReady = false;

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.bindEvents();
      this.createObserver();
      if(!this.options['pause']){
        document.addEventListener("swiper:slide-changed", (e) => {
          const slides = e.detail.element.querySelectorAll('.Banner__Cell');
          slides.forEach((slide, index) => {
            if(index != e.detail.currentIndex){
              if(slide.querySelector('.vjs-playing')){
                if(this.videoPlayer) this.videoPlayer.pause();
              }
            } 
          })
        })
      }
      this.userInteractedBinder = this.userInteraction.bind(this);
      document.addEventListener("click", this.userInteractedBinder);
    }
  }

  userInteraction() {
    if (!this.userInteracted && window.innerWidth > 1024) {
      this.userInteracted = true;
      document.removeEventListener("click", this.userInteractedBinder);
    }
  }

  bindEvents() {
    window.removeEventListener("swiper:slide-changed", this.onSlideChangeListener);
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInicialization();
    } else {
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
      if (event.detail.currentIndex == this.elementPosition) {
        if (!this.element.getAttribute("loaded")) {
          var node = document.createElement("div");
          node.appendChild(
            this.element
              .querySelector("template")
              .content.firstElementChild.cloneNode(true)
          );
          this.element.appendChild(node.firstElementChild).focus();
          this.element.setAttribute("loaded", true);
          if (!this.videoPlayer) {
            this.checkLoaded();
          } else {
            if (this.options['viewport']) {

              this.videoPlayer.play();
              this.createObserver();
            }
          }
        } else {
          if (!this.videoPlayer) {
            this.checkLoaded();
          } else {
            if (this.options['viewport']) {

              this.videoPlayer.play();
              this.createObserver();
            }
          }
        }
      } else if (this.videoPlayer && this.videoPlayer.el_.classList.contains('vjs-playing')) {
        this.videoPlayer.pause();
      }

  }

  videoPlayerInicialization() {
    var _this = this;
    if (!this.element.getAttribute("loaded")) {
      var node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      var isMobile = true;
    } else {
      var isMobile = false;
    }

    let img_plh = "",
        aspect_ratio = "",
        src = "",
        host = "html5",
        autoplay =  this.options['viewport'];

    if (isMobile) {

      img_plh = this.options["plh_mob"];
      if (this.options["aspect_mob"]) {
        aspect_ratio = this.options["aspect_mob"];
      } else {
        aspect_ratio = "9:16";
      }
      if (this.options["control_var"]) {
        if (this.options["videom"].includes('youtube')){
          host = 'youtube';
        } else if(this.options["videom"].includes('vimeo')) {
          host = 'vimeo';
        }
          src = this.options["videom"];

      } else if (this.options["video_inside_media"]) {
        const sources = this.options["videod"]["sources"];;
        let topQuality = null;
        sources.forEach(obj => {
        if(obj.format === 'mp4'){
          if(!topQuality) topQuality = obj;
          if(topQuality.height < obj.height) topQuality=obj;
        }
        });
        const aspectRatioHeight = Math.floor(100 / this.options["videod"]["aspect_ratio"]);
        if (!this.options['videoRatio']){
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality['url'] + "#t=0.001";
      } else {
        const aspectRatioHeight = Math.floor(100 / this.options["videom"]["aspect_ratio"]);
        if (!this.options['videoRatio']){
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == 'youtube'){
          src =
          "https://www.youtube.com/watch?v=" +
          this.options["videom"]["external_id"];
        }else{
          src = this.options["videom"]["external_id"];

        }
        autoplay = false;
      }

    } else {

      img_plh = this.options["plh_desk"];
      if (this.options["aspect_desk"]) {
        aspect_ratio = this.options["aspect_desk"];
      } else {
        aspect_ratio = "16:9";
      }

      if (this.options["control_var"]) {
        if (this.options["videom"].includes('youtube')){
          host = 'youtube';
        } else if(this.options["videom"].includes('vimeo')) {
          host = 'vimeo';
        }
        src = this.options["videod"];
      } else if (this.options["video_inside_media"]) {
        const sources = this.options["videod"]["sources"];;
        let topQuality = null;
        sources.forEach(obj => {
        if(obj.format === 'mp4'){
          if(!topQuality) topQuality = obj;
          if(topQuality.height < obj.height) topQuality=obj;
        }
        });
        src = topQuality['url'] + "#t=0.001";
        const aspectRatioHeight = Math.floor(100 / this.options["videod"]["aspect_ratio"]);
        if (!this.options['videoRatio']){
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(100 / this.options["videod"]["aspect_ratio"]);
        if (!this.options['videoRatio']){
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == 'youtube'){
          src =
          "https://www.youtube.com/watch?v=" +
          this.options["videod"]["external_id"];

        }else{
          src = this.options["videod"]["external_id"];
        }
      }

    }
    if (host == "youtube") {
      var type = "video/youtube";
    } else if(host == "vimeo") {
      var type = "video/vimeo";
    } else {
      var type = "video/mp4";
    }

    if(!this.options['plh']){
      img_plh = false;
    }

    const tempAutoplay = this.options["viewport"] ? "autoplay" : false;

    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: tempAutoplay,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: img_plh,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        playToggle: true,
        captionsButton: false,
        chaptersButton: false,
        subtitlesButton: false,
        remainingTimeDisplay: true,
        pictureInPictureToggle: false,
        volumeControl: false,
        progressControl: {
          seekBar: false,
        },
        fullscreenToggle: true,
        playbackRateMenuButton: false,
      },
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    var videoplayerID = this.element.querySelector("video");

    this.videoPlayer = videojs(videoplayerID, payload);
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";
      if (_this.trueObserver == false && _this.options['pause']) {
        _this.createObserver();
      }

      if(type === 'video/vimeo'){
        const mql = window.matchMedia('(min-width: 1025px)');
        mql.addEventListener('change', _this.setVideoPadding.bind(this));
        _this.setVideoPadding();

        _this.element.classList.add('VimeoPlayer');
        const iframe = _this.element.querySelector('iframe');
        iframe.classList.add('vimeo-iframe');
      }
      else if(type === 'video/youtube'){
        const playBtn = _this.element.querySelector('.Video__PlayButton');
        if(playBtn) playBtn.style.display = "none";
      }

      _this.videoReady = true;
    });

    if(this.options['muted']) this.videoPlayer.muted('true');

    if(this.options["controls"]){
      this.videoPlayer.on("touchstart", function (event) {
        if(event.target.classList.contains('vjs-tech') || event.target.parentElement.classList.contains('vjs-tech')){

          if (!this.paused()) {
            this.pause();
          } else {
            this.play();
          }
        }
      });
    }

    const volumeControl = this.element.querySelector('.vjs-volume-panel');

    volumeControl.addEventListener('mouseenter', () => {
      document.dispatchEvent(new CustomEvent('banner:disable', { bubbles: true }));
    });

    volumeControl.addEventListener('mouseleave', () => {
      document.dispatchEvent(new CustomEvent('banner:enable', { bubbles: true }));
    });
  }

  setVideoPadding(){
    if(this.element){
      const videoJs = this.element.querySelector('.video-js');
      const paddingTop = this.getPaddingInPercent(videoJs);
      const vjsTech = this.element.querySelector('.vjs-tech');

      vjsTech.firstChild.style.paddingTop = paddingTop + "%";
    }
  }

  getPaddingInPercent(elem){
    const computedStyle = window.getComputedStyle(elem);
    const pixelValue = parseFloat(computedStyle.paddingTop.replace('px', ''));
    const parentWidth = elem.parentElement.clientWidth;
    const percentageValue = (pixelValue / parentWidth) * 100;

    return percentageValue;
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
    });

    const target = this.element;
    observer.observe(target);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer || !this.videoReady) {
          this.checkLoaded();
          if(this.options["viewport"]){
            const intervalId = setInterval(() => {
              if (this.videoPlayer) {
                if(this.options['muted']){
                  if(!this.firstTimePlaying && !this.videoPlayer.muted()){
                    this.videoPlayer.muted(false);
                  } else {
                    this.videoPlayer.muted('true');
                  }
                } else {
                  if(this.firstTimePlaying && !this.userInteracted) this.videoPlayer.muted('true');
                }
                this.firstTimePlaying = false;
                this.videoPlayer.play();
                clearInterval(intervalId);
              };
            }, 1000)
          }
          return;
        }
        if (this.options["viewport"] && this.videoPlayer && this.videoReady) {
          if(this.options['muted']){
            if(!this.firstTimePlaying && !this.videoPlayer.muted()){
              this.videoPlayer.muted(false);
            } else {
              this.videoPlayer.muted('true');
            }
          } else {
            if(this.firstTimePlaying && !this.userInteracted) this.videoPlayer.muted('true');
          }
          this.firstTimePlaying = false;
          this.videoPlayer.play();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (this.videoPlayer && this.videoPlayer.el_.classList.contains('vjs-playing') && this.options['pause']) {
          this.videoPlayer.pause();
        }
      }
    });
  }
  
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      this.dropdown = new Dropdown(this.element);
    }
  }
}
customElements.define("footer-component", FooterComponent);

class DropdownSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.dropdown = new Dropdown(this.element);
  }
}
customElements.define("dropdown-section", DropdownSection);

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(
      ".ProductSlider--Thumbnails"
    );

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );


    if(this.options['slides_number'] > 1){
      if(this.options['show_thumbnails']){
        this.carousel = new RevolutionSwiper(
          this.carouselElement,
          this.carouselElementThumbs
        );
        const _this = this;
        setTimeout(() => {
          _this.carouselElementThumbs.style.maxHeight = this.element.querySelector('.ProductSliderCell').offsetHeight + 'px';
        }, 200);


      }else{
        this.carousel = new RevolutionSwiper(
          this.carouselElement
        );
      }
    }

    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );
    var localPickup = this.element.querySelector("#LocalPickup");
    if (localPickup) {
      new Drawer(this.querySelector("#LocalPickup"));
    }
    new AddToCart(this.element);
    new Dropdown(this.element.querySelector(".ProductInfo--Wrapper"));


    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.element, this.carousel);
    }

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }


    if(this.options['variant_image_id'] && this.options['show_variant_image_on_load']){
      this.updateImage();
    }


    this.bindEvents();

    if (new Responsive().matchesBreakpoint('pocket')){
      window.addEventListener("scroll", () => {
        const footer = document.querySelector(".mainFooter--Wrapper");
        const image = document.querySelector(".ProductSlider--Image");


        const footerRect = footer.getBoundingClientRect();


        const imageRect = image.getBoundingClientRect();

        if (
            (footerRect.top >= window.innerHeight || footerRect.bottom <= 0) &&
            (imageRect.top >= window.innerHeight || imageRect.bottom <= 0)
        ) {

            document.querySelector(".pdpATC--desktop").style.display = "block";
        } else {

            document.querySelector(".pdpATC--desktop").style.display = "none";
        }
    });

    }

    window.addEventListener('resize', () =>{

      this.carouselElementThumbs.style.maxHeight = this.element.querySelector('.ProductSliderCell').offsetHeight + 'px';
    })

  }

  bindEvents() {
    this.domDelegate.on("variant:changed", this.updateImage.bind(this));
  }


  updateImage(event) {
    if (event){
      var imageID = event.detail.new_image;
    } else {
      var imageID = this.options['variant_image_id'];
    }

    var selector = "#Image--" + imageID;
    var imageEl = this.element
      .querySelector(selector);

      if(imageEl){

        this.carousel.selectCell(parseInt(imageEl.getAttribute("data-position")));
      }

  }

  changeImageQuality() {
    var imageToReveal = null;
    imageToReveal = this.element.querySelector(
      ".ProductSlider--ImageFirst"
    );
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }




}
customElements.define("product-component", ProductElement);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.bindEvents();
  }

  bindEvents(){
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });
  }


  onQuantityChange(){
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }


  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePickupAvailability();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".ProductInfo--Prices";
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);


        if (source && destinations) {
        destinations.forEach((destination) => {
          destination.innerHTML = source.innerHTML;
        });
      }

        const quantityButton = document.querySelector('.QuantityHandler');
        if(quantityButton){
          const source = html.querySelector('.QuantityHandler');
          if (source && quantityButton) quantityButton.innerHTML = source.innerHTML;
        }
        this.toggleAddButton();
      });
  }



  toggleAddButton() {

    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
          addButtonInner = addButton.querySelector(".SelfAlign"),
          quantityEl = document.querySelectorAll('.QuantitySelector__ProductQuantity');
          if(quantityEl){
                quantity = quantityEl.value;
          }
    if (window.variantInfo.show_icon) {
      var buySvg =
      '<svg class="Svg Svg--basket mr-m" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.3778 3.53889C18.2731 3.40985 18.1161 3.33444 17.95 3.33334H6.38333L6.74444 4.44445H17.2222L15.7389 11.1111H7.40555L4.86666 3.07223C4.81092 2.89909 4.67396 2.76421 4.49999 2.71112L2.22221 2.01112C2.03167 1.95256 1.82437 2.00011 1.67839 2.13585C1.53241 2.27159 1.46994 2.47489 1.5145 2.66918C1.55906 2.86347 1.7039 3.01923 1.89444 3.07778L3.88888 3.68889L6.43888 11.7444L5.52777 12.4889L5.45555 12.5611C4.99065 13.0969 4.972 13.8874 5.4111 14.4445C5.71815 14.8179 6.18382 15.0239 6.66666 15H15.9389C16.2457 15 16.4944 14.7513 16.4944 14.4445C16.4944 14.1376 16.2457 13.8889 15.9389 13.8889H6.57777C6.44766 13.8844 6.32932 13.8123 6.26571 13.6988C6.2021 13.5852 6.20246 13.4466 6.26666 13.3333L7.60555 12.2222H16.1833C16.4481 12.2287 16.6807 12.0473 16.7389 11.7889L18.5 4.01112C18.5342 3.84328 18.4891 3.66904 18.3778 3.53889ZM15 18.3333C15.6903 18.3333 16.25 17.7737 16.25 17.0833C16.25 16.393 15.6903 15.8333 15 15.8333C14.3096 15.8333 13.75 16.393 13.75 17.0833C13.75 17.7737 14.3096 18.3333 15 18.3333ZM8.65555 17.0833C8.65555 17.7737 8.0959 18.3333 7.40555 18.3333C6.71519 18.3333 6.15555 17.7737 6.15555 17.0833C6.15555 16.393 6.71519 15.8333 7.40555 15.8333C8.0959 15.8333 8.65555 16.393 8.65555 17.0833Z" fill="#0C0C0C"/></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity){quantity = 1;}

    if (this.currentVariant.available == false) {
      addButton.setAttribute("disabled", "disabled");
      addButton.classList.add("ProductCard--Sold__Out");
      addButtonInner.classList.add('u-pb1');
      addButtonInner.innerHTML = buySvg + window.variantStrings.soldOut;
    } else {
      addButton.removeAttribute("disabled");
      addButton.classList.remove("ProductCard--Sold__Out");
      if (window.variantInfo.show_price) {
        var priceElement =
          "<span class='u-pb1 ml-s'>" +
          Shopify.formatMoney(
            this.currentVariant.price * quantity,
            window.theme.moneyFormat
          );
        +"</span>";
      } else {
        var priceElement = "";
      }

      addButtonInner.innerHTML =
        buySvg + window.variantStrings.addToCart + priceElement;
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.blogWrapper = this.element.querySelector("#BlogArticleWrapper");
    this.blogElement = this.element.querySelectorAll(".BlogArticle");



    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    if (this.options.layout == "masonary") {
      window.addEventListener('resize', this.setupGetInspredGrid.bind(this));
     document.addEventListener('DOMContentLoaded', this.setupGetInspredGrid.bind(this));
    }
  }

  setupGetInspredGrid() {
    const el = this.blogWrapper;
    if (el.length == 0) {
      return;
    }

    var currentClientWidth = Math.max(
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );


    const items = this.blogElement;
    const lastItem = items[items.length - 1];
    if (items.length == 0) {
      return;
    }

    const itemWidth = parseFloat(window.getComputedStyle(lastItem).width);

    let maxItemHeight = lastItem.offsetHeight;
    const numberOfCols = Math.floor(currentClientWidth / itemWidth);

    let isSmall = false;
    let rowTemp = 0;
    let maxHeight = 0;
    items.forEach((item, i) => {
      let rowHeiht = 0;


      const col = i % numberOfCols;
      const row = Math.floor(i / numberOfCols);

      /*calculate height of row, global max item height */
      if (row > 0) {
        for (let i = 1; i <= row; i++) {
          const preParalelIndex = col + (i - 1) * numberOfCols;
          const paralelEl = items[preParalelIndex];
          rowHeiht = rowHeiht + paralelEl.offsetHeight;

          maxItemHeight =
            maxItemHeight < paralelEl.offsetHeight
              ? paralelEl.offsetHeight
              : maxItemHeight;
        }

        maxHeight = maxHeight < rowHeiht ? rowHeiht : maxHeight;
      }

      /* initialize is small flag for that row */
      if (row !== rowTemp) {
        rowTemp = row;

        isSmall = row % 2 != 0;
      }

      const left = col * itemWidth;

      const top = rowHeiht.toFixed(2);

      if (top !== "NaN") {
        const isHidden = false; //row > numberOfRows-2 && col%2 == 0; //hidden last two blog posts, overflow problem

        if (!isHidden) {
          const padding = isSmall
            ? `${90 + Math.random() * 20}%`
            : `${110 + Math.random() * 40}%`;

          item.querySelector(".BlogItem--Wrapper").style.paddingTop =
            padding + "px";

          const myitem = item;
          myitem.style.cssText = "left:" + left + "px;top:" + top + "px";

          isSmall = !isSmall;
        }
      }
    });

    var elHeight = parseInt(maxHeight) + parseInt(maxItemHeight);
    el.style.cssText =
      "width:" +
      numberOfCols * itemWidth +
      "px;height:" +
      elHeight +
      "px;margin:auto";
  }
}
customElements.define("blog-section", BlogSection);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.searchElement = this;
    this.searchResultsElement = this.element.querySelector(".searchWrapper");

    const isDesktop = new Responsive().matchesBreakpoint('lap-and-up');
    this.pageOverlayElement = isDesktop ? document.querySelector(".pageOverlay") : this.element.querySelector(".searchOverlay");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector('.searchInput--clear');
    new AddToCart(this.element);
    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }

    if (window.theme.showSuggestedSearches) {
      this.getSuggestedSearches();
    }


    const carouselElements = this.element.querySelectorAll(".swiper");

    carouselElements.forEach((element) => {
      const carousel = new RevolutionSwiper(element);
    });

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );




    this.bindEvents();
  }


  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateElement.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
       this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
       this.onRecentSearchClick.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  initCarousel() {

      var carousel = this.searchResultsElement.querySelector(
        "[data-swiper-settings]"
      );
      if (carousel) {
        this.newCarousel = new RevolutionSwiper(carousel);
      }

  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    event.preventDefault();
    
    const _this = this;
    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    const target = event.target;

    // Check if search element exists
    if (!this.element) {
      console.error('Search element not found');
      return;
    }

    // Load recommendations if product is enabled and collection is empty and searchSlide is not present

    if (
      !this.element.querySelector(".searchSlide") &&
      this.options["product"] &&
      !this.options["collection"]
    ) {
      this.loadRecommendations();
    }

    // Show search element and page overlay
    const search = target.parentElement.querySelector(".search");
    if (search) {
      search.setAttribute("aria-hidden", false);
    }
    this.pageOverlayElement.classList.add("is-visible");

    // Disable scrolling on body
    if (bodyScrollLock && this.element) {
      bodyScrollLock.disableBodyScroll(
        this.element.querySelector("[data-scrollable]"),
        bodyScrollLockOptions
      );
    }

    document.body.classList.add('scrollLock');
    document.body.classList.add("search-opened");

     // Focus on search input element after delay
     setTimeout(() => {
      if (_this.searchInputElement) {
        _this.searchInputElement.focus();
      }
    }, 200);

    // Remove transparent class from header if options.transparent is true
    if (this.options["transparent"] && this.heroBanner) {
      const header = document.body.querySelector("#header");
      header?.classList.remove("Header--Transparent");
    }

    // Dispatch menu close event
    if (this.element) {
      this.element.dispatchEvent(
        new CustomEvent("menu:close", { bubbles: true })
      );
    }

    // Set isOpen to true
    this.isOpen = true;

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }
    requestAnimationFrame(() => {
      document.querySelector(".header").classList.remove("Header--Transparent")
      
    });
  }

  closeSearch() {
    event.preventDefault();
    var _this = this;
    if (!this.isOpen) {
      return;
    }
    bodyScrollLock.enableBodyScroll(_this.element, bodyScrollLockOptions);
    document.body.classList.remove('scrollLock');
    document.body.classList.remove("search-opened");

    document.body.querySelectorAll(".search").forEach((item, i) => {
      item.setAttribute("aria-hidden", true);
    });
    _this.pageOverlayElement.classList.remove("is-visible");
    document.body.querySelector(
      "#shopify-section-header"
    ).style.backgroundColor = "transparent";
    document.body.style.position = "relative";
    document.body.style.width = "100%";

    if (this.options["transparent"] && this.heroBanner) {
      const header = document.body.querySelector("#header");
      header?.classList.remove("Header--Transparent");
    }

    this.isOpen = false;
  }


  onInput(event) {
    this.allPredictiveSearchInstances = [];

    this.lastInputValue = event.target.value;

    const _this = this;
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute('aria-hidden','false');
    if (event.target.getAttribute("data-value") && _this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = _this.element.querySelector("searchInput");

      el.setAttribute("value", _this.lastInputValue);
      el.value = _this.lastInputValue;
    } else {
      if (event.keyCode === 13) {
        return;
      }

      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.lastInputValue)}&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,body,tag&section_id=search-predictive`, {

    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);

          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-search-predictive').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });

      this.element.querySelector('.searchWrapper').innerHTML = resultsMarkup;
      this.initCarousel();
      this.element.querySelector('.searchWrapper').style.opacity = 1;
      if (window.theme.showRecentSearches) {
        this.recentSearches();
      }
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }

        throw error;
      });

  }

  loadRecommendations() {
    const _this = this;
    const targetProduct = this.options["product"];
    const recommendationsUrl =
      `${window.Shopify?.routes?.route}recommendations/products?section_id=helper-search_suggested&product_id=${targetProduct}&limit=8`;

    return fetch(recommendationsUrl)
      .then(function (response) {
        return response.text().then(function (content) {
          const container = document.createElement("div");
          const contentWrapper = document.createElement("div");
          contentWrapper.innerHTML = content;
          container.innerHTML = contentWrapper.innerHTML;

          const newSwiper = _this.element.querySelector(".searchInitial--Products");
          newSwiper.innerHTML = container.querySelector(".helper--searchSuggested").innerHTML;

          _this.initCarousel();
          new AddToCart(this.element);
        });
      })
      .catch(function (error) {
        console.error("Error loading recommendations:", error);
      });
  }


 resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;

    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");

   if (window.theme.showRecentSearches) { this.getRecentSearches(); }
    if (window.theme.showSuggestedSearches) {
      this.getSuggestedSearches();
    }
    if (this.options["product"] && this.options["collection"] == "") { this.loadRecommendations(); }


    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute('aria-hidden','true');
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) {}
    }
  }

  getRecentSearches() {
    let appendString = "";
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let elementToAdd = this.element.querySelector(
      ".search--recentResults"
    );
    if (items.length > 0) {
      items.forEach((id, index) => {
        appendString =
          appendString +
          "<li tabIndex='0' data-action='search-string' class='u-p3' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      elementToAdd.innerHTML = appendString;
    }
  }

   getSuggestedSearches() {
    var appendString = "";
    const arr = this.options.items;

    if (arr.length == 0) {
      return;
    }
    arr.sort(function () {
      return 0.5 - Math.random();
    });
    var filtred = arr.filter(function (a) {
      if (!a.includes("_")) {
        return a;
      }
    });

    var i;
    appendString = "";
    for (i = 0; i < 5; i++) {
      if (filtred[i]) {
        var filteredResult = filtred[i].replace(":", " ");
        filteredResult = filteredResult.replace("-", " ");
        appendString =
          appendString +
          "<li tabindex='0' class='u-p3 hoverLinks' data-action='search-string' data-value='" +
          filteredResult +
          "'>" +
          filteredResult +
          "</li>";
      }
    }
    var appElement = this.searchElement.querySelector(
      ".Search--Suggested__results"
    );
    appElement.innerHTML = appendString;
  }
  onRecentSearchClick(event) {
  const clickedSearchWord = event.target.getAttribute("data-value");

  if (clickedSearchWord) {
    // Set the clicked word in the search input
    this.searchInputElement.value = clickedSearchWord;
    this.searchInputElement.focus();

    // Trigger a search with the clicked word (if needed)
    this.onInput({ target: this.searchInputElement });
  }
  }


}
customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

  }


  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() {}

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);



class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }


     if (window.location.href.indexOf("form_type=customer#popupForm") > -1 || window.location.href.indexOf("customer_posted=true#popupForm") > -1) {
      this.options.delay = 0;
      this.openNewsletter();
    } 

      
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    

    if (localKey !== "true") {
      if (this.options.scroll_amount > 0) {
        document.addEventListener("scroll", this.scrollListener);
      } else {
        this.openNewsletter();
      }
    }
  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
  
    document.removeEventListener("scroll", this.scrollListener);
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    document.removeEventListener("scroll", this.scrollListener);
  };
}

customElements.define("newsletter-popup", NewsletterPopup);



/* class ButtonsClass extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);


    let buttons = this.querySelectorAll('.Button--PrimaryOnLight');
    let otherButtons = this.querySelectorAll('.Button--PrimaryOnDark');
    buttons = Array.from(buttons);
    buttons = buttons.concat(Array.from(otherButtons));

    buttons.forEach(function(button) {
      button.addEventListener('mouseenter', function(e) {
        var parentOffset = this.getBoundingClientRect(),
            relX = e.clientX - parentOffset.left,
            relY = e.clientY - parentOffset.top;
        this.querySelector('.button--shape').style.top = relY + 'px';
        this.querySelector('.button--shape').style.left = relX + 'px';
      });

      button.addEventListener('mouseout', function(e) {
        var parentOffset = this.getBoundingClientRect(),
            relX = e.clientX - parentOffset.left,
            relY = e.clientY - parentOffset.top;
        this.querySelector('.button--shape').style.top = relY + 'px';
        this.querySelector('.button--shape').style.left = relX + 'px';
      });
    });
  }
}
customElements.define("buttons-class", ButtonsClass); */




class SliderAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.getAttribute("data-settings"));
    if(this.options.totalBlocks < 6){
      this.animateBig = false;
    }else{
      this.animateBig = true;
    }

    if (this.options.totalBlocks > 0 && this.options.enableAnimation){
      this.announcementBar1 = this.element.querySelector('#announcementBar--SwiperWrapperOne');
      this.announcementBar2 = this.element.querySelector('#announcementBar--SwiperWrapperTwo');
      this.slides = this.element.querySelectorAll(".announcementBar--Slide");
      this.fadeToggle = false;
      this.firstAnimation = true;
      this.bindEvents();
    }
  }

  bindEvents() {
    const mql = window.matchMedia("(min-width: 1025px)");
    mql.addEventListener("change", this.handleMediaQuery.bind(this));
    this.handleMediaQuery(mql);
    this.element.addEventListener("mouseenter",()=>{
      this.handleTransparentHeader();
    })
  }

  handleMediaQuery(mql){
    mql.matches ? this.handleBigAnimation() : this.handleSmallAnimation();
  }

  updatePropertyHeight(){
     const AnnBarHeight = document.querySelector('#shopify-section-announcement_bar');
     let height = getComputedStyle(AnnBarHeight).height;
     document.documentElement.style.setProperty('--announcement-height', height);
  }

  toggleFade() {
    this.announcementBar2.style.display = "flex";

    if (this.fadeToggle) {
      this.announcementBar1.classList.remove('fade-in');
      this.announcementBar2.classList.add('fade-in');
    } else {
      this.announcementBar1.classList.add('fade-in');
      this.announcementBar2.classList.remove('fade-in');
    }

    this.fadeToggle = !this.fadeToggle;
  }

  fadeBig(){
    // Initially fade in the first bar
    this.announcementBar1.classList.add('fade-in');

    this.slides.forEach(slide => slide.style.visibility = "visible");

    if (this.animateBig) this.barsTimeout = setInterval(() => this.toggleFade(), this.options.interval);
  }

  fadeSmall() {
    const mySlides = this.slides;
    const numSlides = mySlides.length;
    let currentSlideIndex = 0;

    const animate = () => {
      if (currentSlideIndex > 0) {
        mySlides[currentSlideIndex - 1].classList.remove('fade-in');
      }

      mySlides[currentSlideIndex].classList.add('fade-in');

      this.slidesTimeout = setTimeout(() => {
        mySlides[currentSlideIndex].classList.remove('fade-in');
        currentSlideIndex = (currentSlideIndex + 1) % numSlides;
        animate();
      }, this.options.interval);
    };

    animate();
  }

  stopFadeBig() {
    this.announcementBar1.style.display = "none";
    this.announcementBar2.style.display = "none";

    this.announcementBar1.classList.remove('fade-in');
    this.announcementBar2.classList.remove('fade-in');

    setTimeout(() => {
      this.announcementBar1.style.display = "flex";
      this.announcementBar2.style.display = "flex";
    }, 100);

    clearTimeout(this.barsTimeout);
  }

  stopFadeSmall() {
    this.slides.forEach(slide => {
      if (slide.classList.contains('fade-in')) {
        slide.classList.remove('fade-in');
      }
    });
    clearTimeout(this.slidesTimeout);
  }

  handleBigAnimation() {
      if (!this.firstAnimation) {
        this.stopFadeSmall();

        this.announcementBar1.style.display = "none";
        if (this.animateBig) this.announcementBar2.style.display = "none";

        setTimeout(() => {
          this.announcementBar1.style.display = "flex";
        }, 75)

        setTimeout(() => {
          this.fadeBig();
        }, 150);
      } else {
        if (this.animateBig) this.announcementBar2.style.display = "none";
        this.fadeBig();
      }
      if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
      this.updatePropertyHeight();
}

handleSmallAnimation() {
    if (!this.firstAnimation && this.animateBig) this.stopFadeBig();

    this.slides.forEach((slide, index) => {
      if (index !== 0) slide.style.display = 'none';
    });

    setTimeout(() => {
      this.fadeSmall();

      this.slides.forEach((slide, index) => {
        if (index !== 0) slide.style.display = 'flex';
      });

      if (this.firstAnimation) this.firstAnimation = !this.firstAnimation;
    }, 150);
    this.updatePropertyHeight();
}

handleTransparentHeader(){
  const header = document.querySelector("#header");
  const search = document.querySelector(".search");

  if(search.getAttribute("aria-hidden") == "false"){
    header.classList.remove("Header--Transparent");
  }

}


}
customElements.define("slider-announcement-bar", SliderAnnouncementBar);


class SearchComposers extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      this.searchBar = this.element.querySelector('#searchBar');
      this.mobile = false;
      this.lastTarget = null;

      this.mql = window.matchMedia('(min-width: 1025px)');
      this.mql.addEventListener('change', this.handleMediaQuery.bind(this));
      this.handleMediaQuery(this.mql);
  }

  handleMediaQuery(mql){
    if(mql.matches) {
      this.bindDesktopEvents();
      this.unbindMobileEvents();
    } else {
      this.bindMobileEvents();
      this.unbindDesktopEvents();
    }
  }

  bindMobileEvents() {
    this.searchBind = this.search.bind(this);
    this.mobileClickBind = this.mobileClick.bind(this);
    this.mobileSwipeBind = this.mobileSwipe.bind(this);
    this.delegateElement.on('input', '[data-action="searchItem"]', this.searchBind);
    this.delegateElement.on('click', '.mobile-letters', this.mobileClickBind);
    this.delegateElement.on('touchmove', '.mobile-letters', this.mobileSwipeBind);
  }

  unbindMobileEvents() {
    this.delegateElement.off('click', '.mobile-letters', this.mobileClickBind);
    this.delegateElement.off('touchmove', '.mobile-letters', this.mobileSwipeBind);
  }

  bindDesktopEvents() {
    this.searchBind = this.search.bind(this);
    this.scrollToBind = this.scrollTo.bind(this);

    this.delegateElement.on('keyup', '[data-action="searchItem"]', this.searchBind);
    this.delegateElement.on('click', '[data-action="scrollToLetter"]', this.scrollToBind);
  }

  unbindDesktopEvents() {
    this.delegateElement.off('keyup', '[data-action="searchItem"]', this.searchBind);
    this.delegateElement.off('click', '[data-action="scrollToLetter"]', this.scrollToBind);
  }

  mobileClick(e) {
    this.scrollTo(e);
  }

  mobileSwipe(e) {
    const touchX = e.touches[0].clientX;
    const touchY = e.touches[0].clientY;

    const currentTarget = document.elementFromPoint(touchX, touchY);
    if(!currentTarget.classList.contains('mobile-letter')) return;

    if (currentTarget !== this.lastTarget) {
      this.lastTarget = currentTarget;
      let letter = currentTarget.innerText;
      let block = this.element.querySelector("#" + letter);
      let block_offset = block.offsetTop;

      const mobileLetters = this.element.querySelector('.mobile-letters');
      const allLetters = Array.from(mobileLetters.children);
      allLetters.forEach((letter) => {
        letter.classList.remove('activeLetter');
      });
      currentTarget.classList.add('activeLetter');

      window.scrollTo({
        'top': block_offset - 120,
        'behavior': 'smooth'
      });
    }
  }

  search() {
    console.log('here');
      let input = this.searchBar.value;
      input = input.toLowerCase();

      let searchableItems = this.element.querySelectorAll('.searchableItem');
console.log('here');
      for (let i = 0; i < searchableItems.length; i++) {
          if (!searchableItems[i].innerText.toLowerCase().includes(input)) {
              searchableItems[i].style.display = "none";
          } else {
              searchableItems[i].style.display = "flex";
          }
      }
  }

  scrollTo(event) {
    let letter = event.target.innerText;
    let block = this.element.querySelector("#" + letter);
    let block_offset = block.offsetTop;
    let focus = this.element.querySelector("[data-scrollable]");
    const mobileLetters = this.element.querySelector('.mobile-letters');

    var allLetters;
    var mobile;
    if(mobileLetters != event.target.parentElement){
      allLetters = this.element.querySelectorAll('[data-action="scrollToLetter"]');
    } else {
      mobile = true;
      allLetters = Array.from(mobileLetters.children);
    }
    allLetters.forEach((letter) => {
      letter.classList.remove('activeLetter');
    });
    event.target.classList.add('activeLetter');

    if (focus && mobileLetters != event.target.parentElement) {
      let focus_offset = focus.offsetTop;
      focus.scrollTo({
        'top' : block_offset - focus_offset,
        'behavior': 'smooth'
      });
    } else {
      window.scrollTo({
        'top': block_offset - (mobile ? 120 : 80),
        'behavior': 'smooth'
      });
    }
  }
}
customElements.define("search-composers", SearchComposers);




class TermsDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    new Dropdown(this.element);
  }
}
customElements.define("terms-dropdown", TermsDropdown);

class SwiperInit extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    const swiper = this.element.querySelector(".swiper");
    new RevolutionSwiper(swiper);
  }
}
customElements.define("swiper-init", SwiperInit);

class BlogSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    this.paddingMobileElem = this.element.querySelector(".paddingMobile");
    this.paddingDeskElem = this.element.querySelector(".paddingDesktop");
    this.swiperTags = JSON.parse(this.getAttribute("data-swiper-tags"));
    this.noTags = this.element.querySelector('.noTags');
    this.firstLoad = true;

    if(this.element.querySelector(".sortByDate")){
      this.dateSortLinks = this.element.querySelectorAll('.articleEventDate');

      this.dateSortLinks.forEach(date => {
        date.addEventListener("click", this.getEventsOfMonth.bind(this));
      })
    }

    if(this.swiperTags){
      var allString = this.element.querySelector('.allTag');
      if(allString) allString = allString.innerHTML;
      this.swiperTags.tags.splice(0, 0, allString);
      this.setDesktopWrappers();
      document.addEventListener('clickedTag', this.handleTagClicked.bind(this));

      const mql = window.matchMedia('(max-width: 1024px)');
      mql.addEventListener('change', this.handleMediaQuery.bind(this));
      this.handleMediaQuery(mql);
    }
  }

  handleMediaQuery(mql){
    mql.matches ? this.mobile = true : this.mobile = false;
    this.noTags ? this.sortByDate() : this.handleTagClicked();
  }

  setDesktopWrappers() {
    const containers = this.element.querySelectorAll('.CalendarShowcase--DesktopWrapper');

    containers.forEach(container => {
      const children = container.querySelectorAll('li').length;
      const rows = Math.ceil(children / 3);
      container.style.gridTemplateRows = `repeat(${rows}, 1fr)`;
    });

    this.carouselElement.swiper.update();
  }

  handleTagClicked(event) {
    const activeSlideIndex = this.carouselElement.swiper.activeIndex;
    const activeSlide = this.carouselElement.swiper.slides[activeSlideIndex];

    let tagText;
    if(event) tagText = event.detail.toLowerCase();
    else tagText = this.element.querySelector('blog-tag-slider .currentTag').innerHTML.trim().toLowerCase();

    const index = this.swiperTags.tags.findIndex(tag => tag.toLowerCase() === tagText);
    const nextSlide = this.carouselElement.swiper.slides[index];

    if(this.firstLoad) this.firstLoad = false;
    else this.element.querySelectorAll('.CalendarShowcase--BlogArticle').forEach(article => article.style.opacity = 1);

    if (index !== -1) {
      activeSlide.classList.remove("fade-in");
      nextSlide.classList.add("fade-in");
      this.carouselElement.swiper.slideTo(index, 0)
      if(this.swiperInit) this.clearSwiper(this.swiper);
      this.sortByDate();
    }
  }

  sortByDate() {
    const activeSlideIndex = this.carouselElement.swiper.activeIndex;
    const activeSlide = this.carouselElement.swiper.slides[activeSlideIndex];
    const swiperElement =  activeSlide.children[0];
    const deskWrapper = activeSlide.children[1];
    const articleElements = Array.from(deskWrapper.querySelectorAll('.CalendarShowcase--BlogArticle'));

    // Extract dates and sort articles based on the event_date
    const sortedArticles = articleElements
      .map(articleElement => {
        if (articleElement.querySelector('.articleEventDate p')) {
          const eventDate = articleElement.querySelector('.articleEventDate p').textContent.trim();
          const dateParts = eventDate.split('.');
          const formattedDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
          return { element: articleElement, date: new Date(formattedDate) };
        } else {
          return { element: articleElement, date: new Date(1000, 1, 1) };
        }
      })
      .sort((a, b) => a.date - b.date)
      .slice(0, this.swiperTags.postLimit);

    while (deskWrapper.firstChild) {
      deskWrapper.removeChild(deskWrapper.firstChild);
    }

    sortedArticles.forEach(sortedArticle => {
      deskWrapper.appendChild(sortedArticle.element);
    });

    this.responsive(deskWrapper, swiperElement, sortedArticles);        
  }

  responsive(deskWrapper, swiperElement, sortedArticles){
    if(this.mobile){
      deskWrapper.style.display = 'none';
      new Swiper('.swiper-slide-active .CalendarShowcase--InnerSwiper', {
        slidesPerView: 1.525,
        spaceBetween: 16,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        breakpoints: {
          375: {
            slidesPerView: 1.525,
            spaceBetween: 16,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          }
        }
      });

      this.swiper = swiperElement.swiper;

      sortedArticles.forEach(sortedArticle => {
        sortedArticle.element.style.display = 'block';
        this.swiper.appendSlide(this.createNewSlide(sortedArticle.element));
      });
      swiperElement.style.display = 'block';
      this.swiperInit = true;
    } else {
      if(window.theme.enableAnimations) this.element.querySelectorAll('.CalendarShowcase--BlogArticle').forEach(article => article.style.opacity = 0);
      swiperElement.style.display = 'none';
      if(this.swiperInit) this.clearSwiper(this.swiper);
      deskWrapper.style.display = '';
    }

    this.carouselElement.swiper.update();
  }

  createNewSlide(elem){
    const newSlide = document.createElement('div');
    newSlide.classList.add('swiper-slide');
    newSlide.innerHTML = elem.outerHTML;

    return newSlide;
  }

  clearSwiper(swiper){
    const wrapperEl = swiper.wrapperEl;
    while (wrapperEl.firstChild) {
      wrapperEl.removeChild(wrapperEl.firstChild);
    }

    swiper.destroy(true, false);
    this.swiperInit = false;
  }

  getEventsOfMonth(event){
    event.preventDefault();

    const clickedDateHTML = event.target.innerHTML;
    const dateParts = clickedDateHTML.split('.');
    const targetMonth = dateParts[1];

    const activeSlideIndex = this.carouselElement.swiper.activeIndex;
    const activeSlide = this.carouselElement.swiper.slides[activeSlideIndex];
    const articleElements = Array.from(activeSlide.querySelectorAll('.CalendarShowcase--BlogArticle'));

    const filteredArticles = articleElements.filter(articleElement => {
      if (articleElement.querySelector('.articleEventDate p')) {
        const eventDate = articleElement.querySelector('.articleEventDate p').textContent.trim();
        const articleDateParts = eventDate.split('.');
        const articleMonth = articleDateParts[1];
        return articleMonth === targetMonth;
      }
      return false;
    });

    articleElements.forEach(articleElement => {
      articleElement.style.display = 'none';
    });

    filteredArticles.forEach(filteredArticle => {
      filteredArticle.style.display = 'block';
    });

    this.sortByDate();

    const clickedDateEvent = new CustomEvent('clickedDate');
    document.dispatchEvent(clickedDateEvent);
    }
}
customElements.define("blog-slider", BlogSlider);


class FAQSection extends HTMLElement {
  constructor() {
    super();
    let foundOne = false;
    const none = document.getElementById('none'); 
    this.element = this;
    this.clearBtn = this.querySelector('.clearSeacrh');
    this.delegateElement = new Delegate(this);
    const searchInput = document.querySelector('input[rel="searchbox"]');
    this.data = document.querySelectorAll(".Faq-Section");
    this.show(false);
    const _this = this;

    const links = document.querySelectorAll('.FAQNav--rowLink');

    links.forEach(link => {
  link.addEventListener('click', function() {
    links.forEach(link => {
      link.classList.remove('active');

       let changeFont = link.querySelector('.nav--name');
       changeFont.classList.remove('u-s3');
       changeFont.classList.add('u-p3');

    });
    this.classList.add('active');
    const activeNavName = this.querySelector('.nav--name');
   activeNavName.classList.remove('u-p3');
    activeNavName.classList.add('u-s3');
  });


});



    searchInput.addEventListener('input', function (event) {

        // reset state
        _this.show(false)
        foundOne = false;
        _this.clearBtn.style.display = 'none';
        const input = event.target
        if (input.value) {
          _this.clearBtn.style.display = 'flex';
          const toMatch = input.value.toLowerCase();


            for (let i = 0, len = _this.data.length; i < len; i++) {
                const match = _this.data[i].innerHTML.toLowerCase().includes(toMatch);
                _this.data[i].style.display = match ? 'block' : 'none';
                if (match) foundOne = true;
            }
          if (!foundOne) {
            _this.show(true);

            _this.querySelector('.faq--group').style.display='none';
          }else{
            _this.querySelector('.faq--group').style.display='flex';
          }
        } else
        _this.resetState()

    });


  

    this.bindEvents();
  }

  bindEvents(){
     this.delegateElement.on(
        "click",
        '[data-action="nav-clicked"]',
        this.handleNavClicked.bind(this)
      );
  }



   faqSearch() {
      let faqs = document.querySelectorAll('.Faq-section_content');
        let search_query = document.getElementById("searchbox").value;
        for (var i = 0; i < faqs.length; i++) {
            if(faqs[i].textContent.toLowerCase()
                    .includes(search_query.toLowerCase())) {
                faqs[i].classList.remove("is-hiddenz");
            } else {
                faqs[i].classList.add("is-hiddenz");
            }
        }
    }


     resetState() {
        for (let i = 0, len = this.data.length; i < len; i++){

          this.data[i].style.display = 'block';
        }

            this.show(false);
            this.inputValue = this.querySelector('#searchbox');

            this.inputValue.value = '';
            this.clearBtn.style.display = 'none'
            if(new Responsive().matchesBreakpoint("lap-and-up")){
            this.querySelector('.faq--group').style.display='flex';
            } else {
                      this.querySelector('.faq--group').style.display='block';
            }

    }
     show(bool) {
      none.style.display = bool ? 'block' : 'none';

     }


}
customElements.define('faq-section', FAQSection);
class collectionShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    if (new Responsive().matchesBreakpoint('pocket')) {
      const swiper = this.element.querySelector(".swiper");
      new RevolutionSwiper(swiper);
    } else {
      const elements = document.querySelectorAll('.collectionShowcase *');
      elements.forEach((element) => {
      element.classList.remove('swiper','swiper-wrapper', 'swiper-slide');
    });
    }
    this.breakpoint = new Responsive().matchesBreakpoint('lap-and-up');
    this.bindEvents();
  }

    bindEvents() {
      if ( this.breakpoint ) {
        this.delegateElement.on("mouseover", '[data-action="toggle-image"]', this.changeImage.bind(this));
      }
    }

  changeImage(event) {
    let activeImage = event.target.getAttribute("data-src");
    this.element.querySelector('.changeImage').remove();
    const img = document.createElement("img");
    img.src = activeImage;
    img.classList.add("changeImage");
    this.element.querySelector(".changeImage-box").append(img);

    let active_title = this.element.querySelector('.desktop-title-active');
    if (active_title) {
      active_title.classList.add('desktop-title');
      active_title.classList.remove('desktop-title-active');
    }
    event.target.classList.remove("desktop-title");
    event.target.classList.add("desktop-title-active");


  }
}
customElements.define("collection-showcase", collectionShowcase);

class SliderQuoteSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    this.swiper = this.carousel.swiperElement;

    this.parseQuotes();
    this.createIntersection();

    this.swiper.on('slideChange', this.updateQuote.bind(this));
  }

  createIntersection(){
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        this.updateQuote();
      });
    });

  observer.observe(this.element);
  }

  updateQuote() {
    var keyframesReg = [
      { color: 'var(--secondary_grey)' },
      { color: 'var(--text_1)' }
    ];

    var keyframesLink = [
      { color: '#98B8EC' },
      { color: 'var(--details_1)' }
    ];

    var keyframesRegOld = [
      { color: 'var(--secondary_grey)' }
    ];

    var keyframesLinkOld = [
      { color: '#98B8EC' }
    ];

    var options = {
      duration: 200,
      easing: 'linear',
      fill: 'forwards'
    };

    var optionsOld = {
      duration: 300,
      fill: 'forwards'
    };

    var delay = 0;

     //Remove color from old slide
     if (this.currentSlide) {
      var words = this.currentSlide.querySelectorAll('.Quote--Letter')
      words.forEach(function(elem) {

        if (elem.closest('a')) {
          if(elem.classList.contains('Quote--Punctuation')){
            // Apply animation for punctuation
            elem.animate(keyframesRegOld, optionsOld);
          } else {
            // Apply animation for text inside <a> element
            elem.animate(keyframesLinkOld, optionsOld);
          }
        }
        else {
          // Apply animation for text outside <a> element
          elem.animate(keyframesRegOld, optionsOld);
        }
      });
    }

    //Animate new slide
    this.currentSlide = this.swiper.slides[this.swiper.activeIndex];
    if (!this.currentSlide) return;

    var letters = this.currentSlide.querySelectorAll('.Quote--Letter')
    letters.forEach(function(elem) {

      if (elem.closest('a')) {
        if(elem.classList.contains('Quote--Punctuation')){
          // Apply animation for punctuation
          options.delay = delay;
          elem.animate(keyframesReg, options);
          delay += 20;
        } else {
          // Apply animation for text inside <a> element
          options.delay = delay;
          elem.animate(keyframesLink, options);
          delay += 20;
        }
      } else {
        // Apply animation for text outside <a> element
        options.delay = delay;
        elem.animate(keyframesReg, options);
        delay += 20;
      }
    });
  }

  parseQuotes() {
    this.element.querySelectorAll('.Quote--Text').forEach((elem) => {

      const text = elem.innerHTML;
      const regex = /(<a[^>]+>[^<]+<\/a>)|\b[\w'-’]+(?:'\w+)?\b/g;
      const matches = [...text.matchAll(regex)];

      // Extract the words along with their positions
      const wordsSplit = [];
      const links = []
      let position = -1;
      matches.forEach(match => {
        const item = match[0];
        if (item.startsWith("<a")) {
          const hrefMatch = /href="([^"]+)"/.exec(item);
          const href = hrefMatch ? hrefMatch[1] : '';
          const innerText = item.replace(/<\/?a[^>]*>/g, '');
          const innerWords = innerText.trim().split(/\s+/);
          innerWords.forEach(word => {
            links.push({ word, href, position });
            position++;
          });
        } else {
          wordsSplit.push({ word: item, position });
          position += item.split(' ').length;
        }
      });

      const words = elem.textContent.trim().split(' ');

      elem.innerHTML = words.map((word, position) => {
        const cleanWord = word.replace(/^\W+|\W+$/g, ''); // Remove leading and trailing non-alphanumeric characters
        const matchingLink = links.find(match =>
          match.word.includes(cleanWord) && match.position === position
      );

        if (matchingLink) {
          let letters = '';
          for (let i = 0; i < word.length; i++) {
            let isPunctuation = (/[“”".,:;]/.test(word[i]));

            if(isPunctuation){
              letters += `<span class="Quote--Letter Quote--Punctuation u-h1">${word[i]}</span>`;
            }else{
              letters += `<span class="Quote--Letter u-h1">${word[i]}</span>`;
            }
          }
          return `<a class="Quote--Word" href="${matchingLink.href}">${letters}</a>`;
        } else {
          let letters = '';
          for (let i = 0; i < word.length; i++) {
            letters += `<span class="Quote--Letter u-h1">${word[i]}</span>`;
          }
          return '<span class="Quote--Word">' + letters + ' </span>';
        }
      }).join(' ');
    })
  }

  removeQuotationMarks(str) {
    if (str.length > 0 && str.charAt(0) === '“' && str.charAt(str.length - 2) === '”') {
      return str.substring(1, str.length - 1);
    }
    return str;
  }
}
customElements.define("slider-quote", SliderQuoteSection);


class BlogTagSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    if(this.element.querySelector(".immediateLink")){
      const tagBullets = this.element.querySelectorAll(".Tag--Bullet");

      tagBullets.forEach(tagBullet => {
        tagBullet.addEventListener("click", this.handleTagClick.bind(this));
      });
    }

    document.addEventListener('clickedDate', this.clearCurrentTag.bind(this));
  }

  handleTagClick(event) {
    const clickedBulletHTML = event.target.innerHTML;
    var index = event.target.getAttribute('aria-label');
    index = index.charAt(0);

    this.clearCurrentTag();
    this.carousel.swiperElement.slideTo(index - 1);
    event.currentTarget.classList.add("currentTag");

    const clickedTagEvent = new CustomEvent('clickedTag', { detail: clickedBulletHTML });
    document.dispatchEvent(clickedTagEvent);
  }

  clearCurrentTag(){
    const prevActiveTag = this.element.querySelector(".Tag--Bullet.currentTag");

    if (prevActiveTag) {
      prevActiveTag.classList.remove("currentTag");
    }
  }
}
customElements.define("blog-tag-slider", BlogTagSlider);

class BlogSectionCustom extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.blogWrapper = this.element.querySelector("#BlogArticleWrapperCustom");
    this.blogArticles = this.element.querySelectorAll(".BlogArticleCustom");
    this.blogItemImages = this.element.querySelectorAll(".BlogItem--Image");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    if (this.options.layout == "masonary") {
      this.blogWrapper.style.flexFlow = "column wrap";

      window.addEventListener('resize', () => {
        if (window.innerWidth >= 768) {
          this.setWrapperHeightDesktop();
        } else {
          this.setWrapperHeightMobile();
        }
      });
      document.addEventListener('DOMContentLoaded', () => {
        if (window.innerWidth >= 768) {
          this.setWrapperHeightDesktop();
        } else {
          this.setWrapperHeightMobile();
        }
      });
    }
  }

  setWrapperHeightMobile() {
    const blogWrapper = this.blogWrapper;
    const articles = this.blogArticles;

    const numColumns = 2; // Set the number of columns in your grid

    let rowHeights = [];
    let currentRowHeight = 0;

    articles.forEach((article, i) => {
      article.style.order = 0;
      const articleHeight = article.offsetHeight;

      if (i % numColumns === 0) {
        // Start of a new row
        if (currentRowHeight > 0) {
          rowHeights.push(currentRowHeight);
        }
        currentRowHeight = articleHeight;
      } else {
        // Compare with the previous image in the row and use the taller height
        currentRowHeight = Math.max(currentRowHeight, articleHeight);
      }

      // For the last image, add the height of the row to the array
      if (i === articles.length - 1) {
        rowHeights.push(currentRowHeight);
      }
    });

    // Switch up order numbers every 2 articles to achieve the masonary grid
    for (let i = 0; i < articles.length; i += 2) {
      if (i % 4 === 2) {
        articles[i].style.order = 2;
        if(!(i == articles.length - 1 && articles.length % 2 != 0)) {
          articles[i + 1].style.order = 1;
        }
      } else {
        articles[i].style.order = 1;
        if(!(i == articles.length - 1 && articles.length % 2 != 0)) {
          articles[i + 1].style.order = 2;
        }
      }
    }

    // If there are 3 articles, manually assign order numbers
    if(articles.length === 3 && this.options.big_article == true){
      articles[0].style.order = 1;
      articles[1].style.order = 2;
      articles[2].style.order = 1;
    }


    // Wrapper height
    const totalHeight = rowHeights.reduce((sum, height) => sum + height, 0);
    blogWrapper.style.height = `${totalHeight + ((rowHeights.length - 1) * 17) + 10}px`;
  }

  setWrapperHeightDesktop(){
    const blogWrapper = this.blogWrapper;
    const articles = this.blogArticles;
    const articlesLength = articles.length;

    let rowNum = Math.ceil(articles.length / 3);

    // Add padding to the second last article, otherwise last wouldn't go to the new row
    if(articlesLength % 3 === 1) articles[articlesLength - 2].style.paddingBottom = "128px";

    if(articlesLength === 2) blogWrapper.style.flexFlow  = "initial";


    // Assign order numbers and calculate wrapper height
    let article;
    let wrapperHeight = 0;
    for (let i = 0; i < articles.length; i += 3) {
      article = articles[i];

      // Select tallest article out of the few as wrapper height
      if(articlesLength === 3 || articlesLength === 2) article = articles[1];
      wrapperHeight += article.offsetHeight;

        articles[i].style.order = 1;
        if(!(i == articlesLength - 1 && articlesLength % 3 != 0)) {
          articles[i + 1].style.order = 2;
          if(!(i + 1 == articlesLength - 1 && articlesLength % 3 != 0)) {
            articles[i + 2].style.order = 3;
          }
        }
    }

    blogWrapper.style.height = wrapperHeight + ((rowNum - 1) * 32) + 1 + "px";
  }
}

customElements.define("blog-section-custom", BlogSectionCustom);


class LocalizationSelectors extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        let responsive = new Responsive();
        let breakpoint = responsive.getCurrentBreakpoint();
        var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
        var location = this.element.getAttribute('data-settings');


          this.delegateElement.on(
              "change",
              '[data-action="country-change"]',
              this.submitForm.bind(this)
          );
          if(location == "sidebarMenu"){
              var additionalOverlay = true;
          }else{
              var additionalOverlay = false;
            }
        if (breakpoint != "phone" && breakpoint != "tablet") {
          if (selectBoxes.length > 0) {
              selectBoxes.forEach((item, i) => {
                  new RevolutionSelectbox(
                      item
                  );
              });
          }
        }else{
          if (selectBoxes.length > 0) {

              selectBoxes.forEach((item, i) => {
                  new RevolutionSelectbox(
                      item, true, additionalOverlay
                  );
              });
          }
        }

    }

    submitForm(){
      event.target.closest('form').submit();

    }

}
customElements.define("localization-selectors", LocalizationSelectors);

class FavoritesDrawer extends HTMLElement {
  static rendered = false;

  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.loader = this.element.querySelector(".spinningLoader");
    this.cartCount = document.querySelector(".FavoritesCount");

    this.loadRecommendations();
    this.toggleFavorites();
    this.bindEvents();

    const openFavourites = false;
    const keepScroll = true;

    if (FavoritesDrawer.rendered) return;

    const _this = this;
    this.rerenderFavorites(openFavourites, keepScroll).then(function () {
      new AddToCart(_this.element);
      FavoritesDrawer.rendered = true;
    });
  }
  unbindEvents(){
        document.removeEventListener('favorite-product:open', this.onFavoritesOpenListener);

          document.removeEventListener(
          'click',
            this._addToFavoritesL
          );

  }
  bindEvents(){


 if(!document.body.classList.contains('listener')){
    this.onFavoritesOpenListener = this.onFavoritesOpen.bind(this);
    this._addToFavoritesL =  this.addToFavorites.bind(this);



    this.delegateBody.on('click', '[data-action="toggle-favorites"]', this._addToFavoritesL);
    document.body.classList.add('listener');
    document.addEventListener('favorite-product:open', this.onFavoritesOpenListener);

    document.addEventListener('favorites:toggle', this.toggleFavorites.bind(this));

 }


  }

  onFavoritesOpen() {
    this.sidebarDrawer.isOpen = true;
  }

  maxHeight() {
    var footer = this.element.querySelector(".CartDrawer--Footer");
    if(footer){
      var footerH = footer.offsetHeight;
    }

    this.element.querySelector(".CartItems--Wrapper").style.height =
      window.innerHeight - footerH + "px";
  }

  getSearchQueryStrings() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    // If we are on a product template, we make sure to remove the main product from the related product
    const bucketSize = 10.0;
    const idBuckets = [];
    items.forEach((id, index) => {
      const key = Math.floor(index / bucketSize);
      if (!idBuckets[key]) {
        idBuckets[key] = [];
      }
      idBuckets[key].push(id);
    });
    return idBuckets.reduce((acc, vall) => {
      const string = vall
        .map(function (id) {
          return "id:" + id;
        })
        .join(" OR ");

      acc.push(string);
      return acc;
    }, []);
  }

  rerenderFavorites(openfavorites, keepScroll) {
    this.loader.classList.add("is-visible");
    var _this32 = this;
    var queryStrings = this.getSearchQueryStrings();
    const promises = [];


    if (queryStrings.length == 0 && !openfavorites) {
       this.loader.classList.remove("is-visible");
       fetch("/?section_id=favorites-drawer").then(function (content) {
        content.text().then(function (html) {
          _this32.replaceContentFav(html);
         _this32.loader.classList.remove("is-visible");
         _this32.loadRecommendations();
        });
      });

    } else {
      this.loader.classList.remove("is-visible");
    }

    queryStrings.forEach((string) => {
      promises.push(
        fetch("/search?view=favorites&type=product&q=" + string, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    });

    promises.reduce(async (acc, val, index) => {
      const content = await val.then((response) => response.text());
      const container = this.element;
      if (!container.length) {
        _this32.replaceContentFav(content, keepScroll);
        _this32.loader.classList.remove("is-visible");
        _this32.maxHeight();
      } else {
        this.loader.classList.remove("is-visible");
      }
    }, Promise.resolve());

    return Promise.resolve();
  }

  replaceContentFav(html, keepScroll) {
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    var number = tempElement
      .querySelector(".countFav")
      .getAttribute("data-count");
    var cartNodeParent = this.element.querySelector(".CartDrawer");
    cartNodeParent.replaceChild(
      tempElement.querySelector("#cartData"),
      this.element.querySelector("#cartData")
    );
    this.toggleFavorites();
    this.loader.classList.remove("is-visible");

    if (keepScroll) return;

    // var focus = this.element.querySelectorAll('[data-scrollable]');
    // focus.forEach((item) =>{
    //   bodyScrollLock.disableBodyScroll(item);
    // });

    return true;
  }

  toggleFavorites() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    var favorites = document.querySelectorAll(".ProductCard--Favorites");
    if(document.body.querySelector('.emptyHearth')){
    if(items.length > 0){
      document.body.querySelector('.emptyHearth').style.display = "none";
      document.body.querySelector('.brokenHearth').style.display = "flex";
    }else{
      document.body.querySelector('.emptyHearth').style.display = "flex";
      document.body.querySelector('.brokenHearth').style.display = "none";
    }}
    favorites.forEach(function (item) {
      var state = item.querySelector('.ProductCard--FavoritesHolder').getAttribute("state");
      var myID = item.querySelector('.ProductCard--FavoritesHolder').getAttribute("data-id");

      if (state == "not-active" && items.includes(myID)) {

        item.querySelector(".brokenHearth").style.display = "flex";
        item.querySelector(".emptyHearth").style.display = "none";
        item.querySelector('.ProductCard--FavoritesHolder').setAttribute("state", "active");
      } else if (!items.includes(myID)) {
        item.querySelector(".brokenHearth").style.display = "none";
        item.querySelector(".emptyHearth").style.display = "flex";
        item.querySelector('.ProductCard--FavoritesHolder').setAttribute("state", "not-active");
      }
    });
  }

  removeFromFavorites(productId) {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    items = items.filter((c) => c != productId);

    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
    } catch (error) {
      console.log(error);
    }
    var _this = this;
    this.toggleFavorites();
      this.rerenderFavorites(false,false).then(function () {
        new AddToCart(_this.element);
      });
  }

  loadRecommendations() {

    var _this = this;

     if (this.options["productId"] == "") {
      var url = "?section_id=fav-recommendations";
    } else {
      var url =
        window.Shopify?.routes?.route +
        "recommendations/products?section_id=fav-recommendations&product_id=" +
        this.options["productId"] +
        "&limit=10";
    }

    return fetch(url).then(function (response) {
      return response.text().then(function (content) {
        var container = document.createElement("div");
        container.innerHTML = content;

        if(container){
            var z = container.querySelector(".favUpsell").innerHTML;
          var x = _this.element.querySelector(".FavoritesRecommendations");
          if(x != null){
          x.innerHTML = z;}
        }


        const swiper = new Swiper(".swiperUpsell", {
          // Default parameters
          slidesPerView: 2.185,
          spaceBetween: 16,
          navigation: false,
          loop: false,
          slidesOffsetAfter: 16,
          slidesOffsetBefore: 16,
          navigation: {
            nextEl: ".swiperNextId--favorites-drawer",
            prevEl: ".swiperPrevId--favorites-drawer"
          },
          pagination: {
            el: ".favoritePaginatio",
            type: "bullets"
          },
          breakpoints: {
            1024: {
                slidesPerView: 2.68,
                spaceBetween: 16,
                slidesOffsetAfter: 32,
                slidesOffsetBefore: 32
            },
          },
        });
        new AddToCart(x);
        _this.toggleFavorites();
        _this.element.querySelector('.swiperFavorites')?.classList.add('is-visible');
     
        if (window.theme.enableImageAnimations) {
          new RevolutionAnimation(_this.element);
        }
      });
    });
  }


  addToFavorites(event) {
    var _this = this;
    event.preventDefault();


    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    var productId = event.target.getAttribute("data-id");

    // We check if the current product already exists, and if it does not, we add it at the start
    if (!items.includes(productId) && productId != "") {
      items.unshift(productId);
    } else {
      this.removeFromFavorites(productId, false);
      //   this._favoritesNumber();
      return;
    }
    // Then, we save the current product into the local storage, by keeping only the 50 most recent
    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
    
      this.toggleFavorites();

      const openDrawer = false;
      const keepScroll = true;
      this.rerenderFavorites(openDrawer, keepScroll)

      if (this.sidebarDrawer.isOpen == true) {
    this.rerenderFavorites().then(function () {
      new AddToCart(_this.element);
    });  }
    } catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
    }
  }
}
customElements.define("favorites-drawer", FavoritesDrawer);


class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector('#accountDrawer'));
 this.bindEvents();

  }
  bindEvents(){

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on('click', '[data-action="submit-register"]', this.submitRegistration.bind(this));

    this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on('click', '[data-action="submit-recovery"]', this.accountRecover.bind(this));

    this.delegateElement.on('keypress', '[data-action="submit-input-login"]', this.accountInputSubmit.bind(this));
    this.delegateElement.on('keypress', '[data-action="submit-input-reg"]', this.accountInputSubmitReg.bind(this));
    this.delegateElement.on('keypress', '[data-action="submit-input-forgot-pass"]', this.accountInputSubmitForgot.bind(this));
}


accountInputSubmitForgot(event){

   if (event.key === "Enter") {
    event.preventDefault();
   this.accountRecover(event);
  }
}

accountInputSubmitReg(event){

  if (event.key === "Enter") {
  this.submitRegistration(event);
  }
}

accountInputSubmit(event){

  if (event.key === "Enter") {
    this.submitLogin(event);
  }

}
toggleRecovery(){
  event.preventDefault();
  const id = event.target.dataset.id;

  if (id == 'recoverFlex'){
    this.element.querySelector('#recoverFlex').setAttribute('aria-visible','true');
    this.element.querySelector('#loginFlex').setAttribute('aria-visible','false');
  }
   else{
    this.element.querySelector('#recoverFlex').setAttribute('aria-visible','false');
    this.element.querySelector('#loginFlex').setAttribute('aria-visible','true');
   }

   const inputRecovery = this.element.querySelector('#RecoverEmail');
    const _this = this;

   inputRecovery.addEventListener('keypress', function (event) {
    if(event.key === 'Enter'){
     event.preventDefault();
     _this.accountRecover(event);
    }
   })
   }

accountRecover(event){
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = '/account/recover';

    // Create the request body with the registration data
    const requestBody = {
        'email': this.element.querySelector('#RecoverEmail').value
    };

    _this.querySelector('.accountBtn--recovery .button--text').style.visibility = "hidden";
    _this.querySelector('.accountBtn--recovery .itemLoader').classList.add('is-visible');

    // Send the AJAX request
    (async function() {
      try {
            // If hCaptcha is present, append the info into the request body
            if (window.hcaptcha) {
              const captchaToken = await window.hcaptcha.execute(null, { async: true });
              requestBody['h-captcha-response'] = captchaToken.response;
            }
            
        const response = await fetch(registrationEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        const responseText = await response.text();

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = responseText;

        if (responseText.indexOf('RecoverEmail-email-error') !== -1) {

          _this.element.querySelector('#recoverFlex .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('#RecoverEmail-email-error').innerHTML;
        } else if(responseText.indexOf('recoverSuccess') !== -1) {


          _this.element.querySelector('#recoverFlex .accountDrawer--SuccessSpace').innerHTML = tempDiv.querySelector('#recoverSuccess').innerHTML;
        }

        _this.element.querySelector('.accountBtn--recovery .button--text').style.visibility = "visible";
        _this.element.querySelector('.accountBtn--recovery .itemLoader').classList.remove('is-visible');


      } catch (error) {
        console.log('An error occurred during the registration request:', error);
      }
    })();
}

submitRegistration(event) {

  const _this = this;
  const registrationEndpoint = '/account';

  // Create the request body with the registration data
  const requestBody = {
    'customer': {
      'first_name': this.element.querySelector('#register #RegisterForm-FirstName').value,
      'last_name': this.element.querySelector('#register #RegisterForm-LastName').value,
      'email': this.element.querySelector('#register #RegisterForm-email').value,
      'password': this.element.querySelector('#register #RegisterForm-password').value
    }
  };

  /*event.target.querySelector('.ButtonText').style.visibility = "hidden";
  event.target.querySelector('.itemLoader').classList.add('is-visible');*/

  // Send the AJAX request
  (async function() {
    try {
       // If hCaptcha is present, append the info into the request body
       if (window.hcaptcha) {
        const captchaToken = await window.hcaptcha.execute(null, { async: true });
        requestBody['h-captcha-response'] = captchaToken.response;
      }

      const response = await fetch(registrationEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      const responseText = await response.text();

      if (responseText.indexOf('registerErrors') !== -1) {
        console.log('Error occurred during registration');
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = responseText;

        _this.element.querySelector('#register .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('.registerErrors').innerHTML;
      } else {
        
        location.href = window.routes.account_url;
      }

     /* event.target.querySelector('.ButtonText').style.visibility = "visible";
      event.target.querySelector('.itemLoader').classList.remove('is-visible');*/


    } catch (error) {
      console.log('An error occurred during the registration request:', error);
    }
  })();
}


submitLogin(event){
  event.preventDefault();
  const _this = this;
  const loginEndpoint = '/account/login';

  console.log()

  // Create the request body with the login credentials
  const requestBody = {
    'customer': {
      'email': this.element.querySelector('#customer_login #CustomerEmail').value,
      'password': this.element.querySelector('#customer_login #CustomerPassword').value
    }
  };

  /*event.target.querySelector('.ButtonText').style.visibility = "hidden";
  event.target.querySelector('.itemLoader').classList.add('is-visible');*/

  // Send the AJAX request
  (async function () {
    try {
         // If hCaptcha is present, append the info into the request body
         if (window.hcaptcha) {
          const captchaToken = await window.hcaptcha.execute(null, { async: true });
          requestBody['h-captcha-response'] = captchaToken.response;
        }
  
      const response = await fetch(loginEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      
        const responseText = await response.text();

        if (responseText.indexOf('loginError') !== -1) {
          console.log('Incorrect email or password');
          const tempDiv = document.createElement('div');

          tempDiv.innerHTML = responseText;

          _this.element.querySelector('#login .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('.AlertError').innerHTML;
         /* event.target.querySelector('.ButtonText').style.visibility = "visible";
          event.target.querySelector('.itemLoader').classList.remove('is-visible');*/
        } else {

          location.href = window.routes.account_url;

        }



    } catch (error) {
      console.log('An error occurred during the login request:', error);
    }
  })();

}

toggleTab(event) {
  const id = event.target.dataset.id;
  const allTabs = this.element.querySelectorAll('.accountDrawer--Tab[aria-expanded="true"]');
  const allContent = this.element.querySelectorAll('.accountContent');

  allTabs.forEach((tab) => {
    tab.setAttribute('aria-expanded', 'false');
  });

  event.target.setAttribute('aria-expanded', 'true');

  allContent.forEach((content) => {
    content.setAttribute('aria-visible', 'false');
  });

  const content = this.element.querySelector(`#${id}`);
  if (content) {
    content.setAttribute('aria-visible', 'true');
  }
}

}

customElements.define("account-handler", AccountHandler);

class AnimationText extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bind();
  }

  bind(){
        setTimeout(() => {
          // Get the original metaItem--animHolder element
        let originalAnimHolder = this.querySelector('.metaItem--animHolder');

        // Create a deep clone of the original animHolder element
        let clonedAnimHolder = originalAnimHolder.cloneNode(true);

        // Add the cloned animHolder element to the parent div
        let metaItemContent = this.querySelector('.metaItem--content');
        metaItemContent.appendChild(clonedAnimHolder);

        const animArray = this.querySelectorAll('.metaItem--animHolder');
        let i = 0;
        animArray.forEach((item) => {
          item.classList.add(`animHolder--${i}`);
          i++;
        })

        this.querySelector('.metaItem--animHolder.animHolder--1').style.opacity = 0;
        setTimeout(() => {
          this.querySelector('.metaItem--animHolder.animHolder--1').style.opacity = 1;
        }, 15000);

      }, 50);

}

}

customElements.define("animation-text", AnimationText);

function checkAnimation(element){
  if(!window.theme.enableAnimations){
    const revealElements = element.querySelectorAll('.reveal');
    revealElements.forEach(elem => elem.classList.remove('reveal'));
  }
}

class ImageText extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    checkAnimation(this.element);
  }
}
customElements.define("image-text", ImageText);

class CustomImages extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    checkAnimation(this.element);
    this.bindObserver();
  }

  bindObserver() {
    const observedElem = this.element.querySelector(".articleWrapper--customImages");
    const toReveal = this.element.querySelectorAll(".customImage--Image");

    if (!toReveal || !observedElem) return;

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting || entry.intersectionRatio == 1) {
          toReveal.forEach(elem => elem.classList.add('show'));
          observer.unobserve(entry.target);
        }
      });
    });

    observer.observe(observedElem);
  }
}
customElements.define("custom-images", CustomImages);

class BlogHeader extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.blogPage = false;

    if(this.checkUrl()){
      this.mql = window.matchMedia('(max-width: 1024px)');
      this.mql.addEventListener('change', this.handleMediaQuery.bind(this));
      this.handleMediaQuery(this.mql);
    }
  }

  handleMediaQuery(mql) { mql.matches ? this.bindSwipeEvents() : this.unbindSwipeEvents(); }

  bindSwipeEvents() {
    this.handleTouchStart = (event) => this.onTouchStart(event);
    this.handleTouchMove = (event) => this.onTouchMove(event);
    this.handleTouchEnd = () => this.onTouchEnd();

    document.addEventListener("touchstart", this.handleTouchStart);
    document.addEventListener("touchmove", this.handleTouchMove);
    document.addEventListener("touchend", this.handleTouchEnd);
  }

  unbindSwipeEvents(){
    if(this.handleTouchStart) document.removeEventListener("touchstart", this.handleTouchStart);
    if(this.handleTouchMove) document.removeEventListener("touchmove", this.handleTouchMove);
    if(this.handleTouchEnd) document.removeEventListener("touchend", this.handleTouchEnd);
  }

  onTouchStart(event) {
    this.touchStartX = event.touches[0].clientX;
  }

  onTouchMove(event) {
    this.touchEndX = event.touches[0].clientX;
  }

  onTouchEnd() {
    const swipeDistance = this.touchEndX - this.touchStartX;
    const swipeThreshold = 150;

    if (swipeDistance > swipeThreshold) {
      // Right swipe detected
      const prevArticle = this.element.querySelector('#Article--PreviousArticle');
      if(prevArticle.href && !prevArticle.classList.contains('disable')) window.location.href = prevArticle;
    } else if (swipeDistance < -swipeThreshold) {
      // Left swipe detected
      const nextArticle = this.element.querySelector('#Article--NextArticle');
      if(nextArticle.href && !nextArticle.classList.contains('disable')) window.location.href = nextArticle;
    }
  }

  checkUrl() {
    const currentURL = window.location.href;
    const searchString = "blogs/blog/";

    const searchStringIndex = currentURL.indexOf(searchString);

    if (searchStringIndex !== -1) {
      const subPath = currentURL.substring(searchStringIndex + searchString.length);
      return subPath.length > 0 ? true : false;
    }
  }
}
customElements.define("blog-header", BlogHeader);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delElem = new Delegate(this.element);

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
  }

  connectedCallback() {
    this.delElem.on('click', '[data-action="change-quantity"]', this.onQuantityChange.bind(this));
    this.delElem.on('change', '.QuantitySelector__ProductQuantity', this.updateForm.bind(this));
  }

  onQuantityChange(event) {    
    const button = event.target.querySelector("button") || event.target;
    const input = button.parentElement.querySelector("input");
    const previousValue = input.value;
    
    button.name === "plus" ? input.stepUp() : input.stepDown();    
    if (previousValue === input.value && input.classList.contains("quantity-selector__quick-add-input") && button.name === "minus") {
      input.value = 0;
    } else if (previousValue === input.value) {
      return;
    }

    // stepUp() and stepDown() update value but don't update dom element it self so setAttribute is needed
    input.setAttribute("value", input.value);
  
    input.dispatchEvent(new Event("quantity:changed", { bubbles: true }));
    this.updateForm(null, input);
  }

  updateForm(event, target) {    
    let newValue = parseInt(target.value);
    const min = parseInt(target.min), max = parseInt(target.max);
        
    if (max && newValue > max) newValue = max;
    if (min && newValue < min) newValue = target.classList.contains("quantity-selector__quick-add-input") ? 0 : min;    
    
    target.value = newValue;

    const formQuantityInput = document.querySelector('.quantity-input[name="quantity"]');
    if (!formQuantityInput) return;
    
    formQuantityInput.value = newValue;
  }

  // currently not used
  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
          addButtonInner = addButton.querySelector(".SelfAlign"),
          quantityEl = document.querySelectorAll('.QuantitySelector__ProductQuantity');

    if(quantityEl) {
      quantity = quantityEl.value;
    }

    if (window.variantInfo.show_icon) {
      var buySvg =
      '  <svg class="Svg--shopping_bag-line mr-sl" width="20" height="20"viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"  ><path d="M13.8889 6.66666V5.02777C13.8889 3.6384 13.1477 2.35458 11.9444 1.65989C10.7412 0.965211 9.25877 0.965211 8.05555 1.65989C6.85232 2.35458 6.1111 3.6384 6.1111 5.02777V8.91666C6.1111 9.22348 6.35983 9.47222 6.66666 9.47222C6.97348 9.47222 7.22221 9.22348 7.22221 8.91666V7.77777H11.6667V6.66666H7.22221V5.02777C7.22221 3.49365 8.46587 2.24999 9.99999 2.24999C11.5341 2.24999 12.7778 3.49365 12.7778 5.02777V8.88888C12.7778 9.19571 13.0265 9.44444 13.3333 9.44444C13.6401 9.44444 13.8889 9.19571 13.8889 8.88888V7.77777H16.6667V17.7778H3.33332V7.77777H4.99999V6.66666H2.22221V17.8278C2.22221 18.4138 2.69729 18.8889 3.28332 18.8889H16.7167C17.3027 18.8889 17.7778 18.4138 17.7778 17.8278V6.66666H13.8889Z" fill="#0C0C0C" /></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity) quantity = 1;

    addButton.removeAttribute("disabled");
    addButton.classList.remove("ProductCard--Sold__Out");

    if (window.variantInfo.show_price) {
      var priceElement =
        "<span class='u-pb1 ml-s'>" +
          Shopify.formatMoney(
            this.options['price'] * quantity,
            window.theme.moneyFormat
          );
        + "</span>";
    } else {
      var priceElement = "";
    }

    addButtonInner.innerHTML = buySvg + window.variantStrings.addToCart + priceElement;
  }
}

customElements.define("quantity-input", QuantityInput);

// only on mobile
// checks if product is already in the cart, if so then it hides atc button and shows quantity selector instead, quantity selector acts as atc button
class QuickAdd extends HTMLElement {
  constructor() {
    super();

    const breakpoint = new Responsive().matchesBreakpoint("lap-and-up");
    if (breakpoint) return;    
    
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.id = this.element.dataset.productid;
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.input = this.element.querySelector(".QuantitySelector__ProductQuantityMobile");

    this.quantitySelectorElement = this.element.querySelector("quantity-input");
    this.addToCartButton = this.element.querySelector('[data-action="add-to-cart"]');

    this.toggleQuickAdd();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on("cart:changed", this.toggleQuickAdd.bind(this));

    this.delegateElement.on('click', '[data-action="change-quantity"]', this.quickAdd.bind(this));
    this.delegateElement.on('change', '.quantity-select__input', this.quickAdd.bind(this));
  }

  toggleQuickAdd() {      
    const template = this.element.dataset.template;
    if (template.includes('subscription') || !this.quantitySelectorElement) return;

    const cartedProducts = JSON.parse(sessionStorage.getItem("carted_products"));    
    const product = cartedProducts[this.id];

    if (!product) {
      this.quantitySelectorElement.classList.add("hidden");
      this.addToCartButton?.classList.remove("hidden");

      return;
    }

    this.quantitySelectorElement.classList.remove("hidden");
    this.addToCartButton?.classList.add("hidden");

    // update inputs value
    const input = this.element.querySelector(".quantity-selector__quick-add-input");
    if (!input) return;

    input.value = product.quantity;
    input.setAttribute("value", product.quantity);   
  }

  async quickAdd(event, target) {
    this.cartDrawer = document.querySelector('cart-drawer');
    this.sidebarDrawer = new Drawer(this.cartDrawer);

    this.pageLoader.style.width = "100%";

    const input = target.parentElement.querySelector('input');
    const quantity = input.value;
    const variantId = input.dataset.variantId

    const cartItem = document.querySelector(`#CartItem-${variantId}`)
    const lineItemId = cartItem?.dataset.key || variantId;

    try {
        const response = await fetch(`/cart/change.js`, {
            body: JSON.stringify({
                id: lineItemId,
                quantity: quantity,
            }),
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        });

        if (!response.ok) throw new Error("Failed to update cart");

        this.element.dispatchEvent(new CustomEvent("cart:rerender", {
            bubbles: true,
            detail: { lineItem: lineItemId, quantityChange: quantity, skipEvent: true },
        }));

        this.pageLoader.style.left = "unset";
        this.pageLoader.style.right = "0px";
        this.pageLoader.style.width = "0%";

        setTimeout(() => {
            this.pageLoader.style.left = "0px";
            this.pageLoader.style.right = "unset";
            this.sidebarDrawer.openDrawer();
        }, 550);

    } catch (error) {
        console.error("Error updating cart: ", error);
    }
  }

  toggleButton() {

  }
}

customElements.define("quick-add", QuickAdd);